import React from "react";
import {
  Button,
  Row,
  Col,
  CardBody,
  Collapse,
  Card,
  Input,
  Label,
  Table,
  DropdownItem,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import Switch from "COMPONENTS/CommonComponents/Switch/Switch";

// Images
import ic_edit from "ASSETS/Images/ic_edit.svg";
import ic_add from "ASSETS/Images/ic_add_storage.svg";
import ic_error from "ASSETS/Images/ic_error.svg";
import ic_arrow_down from "ASSETS/Images/ic_arrow_down.svg";
import ic_info_grey from "ASSETS/Images/info/ic_info_grey.svg";

// Constants
import {
  modulesAvailableConstant,
  listOfAvailableSubModule,
  notifySetting,
  subLoggingLevels, loggingLevel, 
  defaultSubLoggingLevels,
  downloadableModules,
  STORAGE_LOCATION, TIMEOUT, CONFIG,
  BANDWIDTH_MANAGEMENT_LIST, Modules,
  FRAMES_PER_SECOND_LIST, DEFAULT_FPS,
  BUSINESS_MODELS, cobrowseTypes, LOCATOR,
  RECORDING_METHOD, RECORDING_TARGET,
  STORAGE, ERROR, SCREEN_MASK_MODE, passwordPolicy, 
  maxPassLength, minPassLength, passwordPolicyNum, passwordPolicyName, maxPassHist, minPassHist,
  approvalSettings, CONTRACT_DISPLAY_METHOD,
  BANDWIDTH_CUSTOM, BANDWIDTH_CUSTOM_BANDWIDTH_LIST, BANDWIDTH_CUSTOM_SIZE_DEFAULT, BANDWIDTH_CUSTOM_BITRATE_DEFAULT,
} from "UTILS/Constants";

// Strings
import { getMessage } from "CONFIG/i18n";
import { separatePhoneNumberAndEmails, checkEmpty, hasWhiteSpace } from "UTILS/Utility";
import validator from "validator";
import "./SettingsPage.less"
import "./../Organisations/Organisations.less";
import NumericInput from 'react-numeric-input';

import { validateCobrowseCustomURL, validateSetRecordingPassword } from "UTILS/regexValidations";

import CobrowseSettingsSection from "./../SettingsPage/CobrowseSettingsSection";
import EmailSettingsSection from "./EmailSettingsSection";
import InboundCobrowseSettingsSection from "./../SettingsPage/InboundCobrowseSettingsSection";
import UiGuestSettingsSection from "./../SettingsPage/UIGuestSettingsSection";
import SupportCenterSettingsSection from "./SupportCenterSettingsSection";
import DeleteConfirmationModal from "./DeleteConfirmationModal";
import DeleteItemModal from "./DeleteItemModal";

import _ from "lodash";
import moment from 'moment';

class SettingsPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      allowedDownloads: _.cloneDeep(this.props.allowedDownloads) || {},
      subModulesScreenshare: _.cloneDeep(this.props.subModulesScreenshare) || {},
      subModulesAudioVideo: _.cloneDeep(this.props.subModulesAudioVideo) || {},
      subModulesCoBrowse: _.cloneDeep(this.props.subModulesCoBrowse) || {},
      subModulesSnapShot: _.cloneDeep(this.props.subModulesSnapShot) || {},
      autoRecordSession: false,
      allowAgentToRecordSession: false,
      allowAwsRadioBtn: false,
      allowFtpRadioBtn: false,
      contextExchangeCheckBox: false,
      sessionDetailsCheckBox: true,
      inviteeListCheckBox: true,
      subLoggingLevels: this.props.availableSubLoggingLevels ? _.cloneDeep(this.props.availableSubLoggingLevels) : [...defaultSubLoggingLevels],
      // storageDetails: this.props.storageDetails ? _.cloneDeep(this.props.storageDetails) : {},
      storage: {
        storageDetails: this.props.storageDetails ? _.cloneDeep(this.props.storageDetails) : {},
        bucketName: "",
        id: "",
        secret: "",
        storageErrorMessage: "",
      },
      SSODetails: this.props.SSODetails ? _.cloneDeep(this.props.SSODetails) : {},
      bandwidthSettings: this.props.bandwidthSettings ? _.cloneDeep(this.props.bandwidthSettings) : {}, 
      spinnerVisibility: false,
      clientId: "",
      cognitoDomain: "",
      identityProvider: "",
      clientSecret :"",
      userPoolId:"",
      videoStreamBandwidth: "0",
      screenShareBandwidth: "0",
      videoStreamFPS: DEFAULT_FPS,
      screenShareFPS: DEFAULT_FPS,
      videoStreamCustomSize: BANDWIDTH_CUSTOM_SIZE_DEFAULT,
      videoStreamCustomBitrate: BANDWIDTH_CUSTOM_BITRATE_DEFAULT,
      screenShareCustomSize: BANDWIDTH_CUSTOM_SIZE_DEFAULT,
      screenShareCustomBitrate: BANDWIDTH_CUSTOM_BITRATE_DEFAULT,
      emailIds:(this.props.concurrentSessionData.concurrentSessionNotifyEmails && this.props.concurrentSessionData.concurrentSessionNotifyEmails.length > 0) ? this.props.concurrentSessionData.concurrentSessionNotifyEmails.join() : "",
      emailErrorMessage:'',
      concurrentSessionThreshold:this.props.concurrentSessionData.concurrentSessionThreshold,
      showAddTargetSiteSection: false,
      targetSiteLabel: "",
      targetSiteValue: "",
      targetSites: _.cloneDeep(this.props.cobrowseSettings.targetSites),
      cobrowseSettings:this.props.cobrowseSettings ? _.cloneDeep(this.props.cobrowseSettings) : {},
      allowCustomUrl: _.cloneDeep(this.props.cobrowseSettings.allowCustomUrl),
      customUrlLabels: _.cloneDeep(this.props.cobrowseSettings.customUrlLabels),
      showUpdateTargetSiteSection: false,
      targetSiteIdToEdit:"",
      cobrowseURLError:"",
      customUrlLabelError:"",
      maxSmsSend: this.props.concurrentSessionData.maxSmsSend,
      isSMSEnabled: this.props.concurrentSessionData.isSMSEnabled,
      recordingMethod: this.props.recordingMethod || RECORDING_METHOD.OFF,
      recordingTarget: this.props.recordingTarget ? _.cloneDeep(this.props.recordingTarget) : [],
      modalRecordingMessage: this.props.modalRecordingMessage,
      audioRecordingMessage: this.props.audioRecordingMessage,
      videoRecordingMessage: this.props.videoRecordingMessage,
      retentionPeriod: this.props.retentionPeriod || 0,
      newRecordingPassword: "",
      confirmRecordingPassword: "",
      recordingPasswordErrorMessage: "",
      recordingStorage: {
        storageDetails: this.props.recordingStorageDetails ? _.cloneDeep(this.props.recordingStorageDetails) : {},
        bucketName: "",
        id: "",
        secret: "",
        storageErrorMessage: "",
        saveStorageErrorMessage: "",
      },
      senderId: this.props.concurrentSessionData.sender_id,
      senderIdErrorMessage:'',
      // Co-Browse Mutual Edit
      mutualEdit: this.props.cobrowseSettings.mutualEdit,
      notifyPasswordChangeCompleted: this.props.userNotifySetting ? this.props.userNotifySetting.passwordChangeCompleted || false : true,
      notifyQRCode: this.props.userNotifySetting ? this.props.userNotifySetting.qrCode || false : true,
      isUserInventMsgCustomizeEnable: this.props.userInventMsgCustomize ? this.props.userInventMsgCustomize.isEnable || false : false,
      //isReductionLogs: this.props.isReductionLogs ? (this.props.isReductionLogs.isEnable ? true : false) : true,
      isReductionLogs: true,
      emailAddresses: this.props.userInventMsgCustomize ? this.props.userInventMsgCustomize.emailAddresses || [] : [],
      showAddEmailSection: false,
      emailValue: "",
      emailError: "",
      // password policy
      passwordLength: this.props.concurrentSessionData.password_length,
      useUpper: this.props.concurrentSessionData.use_pw_uppercase,
      useLower: this.props.concurrentSessionData.use_pw_lowercase,
      useNumber: this.props.concurrentSessionData.use_pw_number,
      useSpecialChar: this.props.concurrentSessionData.use_pw_special_char,
      pastPasswordLimit: this.props.concurrentSessionData.check_past_password,
      policyErrorMessage: '',
      screenMaskMode: this.props.screenMaskSetting ? this.props.screenMaskSetting.mode : SCREEN_MASK_MODE.AGENT,
      isEntryAllowed:  this.props.isEntryAllowedSettings ? (this.props.isEntryAllowedSettings.isEnable ? true : false) : false,
      horizontalDisplayFixed: this.props.horizontalDisplayFixedSettings ? this.props.horizontalDisplayFixedSettings.isEnable || false : false,
      disableCanvasEdit: this.props.disableCanvasEdit ? this.props.disableCanvasEdit.isEnable || false : false,
      disableIcsFile: this.props.disableIcsFile ? this.props.disableIcsFile.isEnable || false : false,
      targetSkillId: "",
      targetSkillName: "",
      targetReceptionStartTime: "",
      targetReceptionEndTime: "",
      targetIsReceptionDisabledOnExceptionDays: false,
      targetExceptionStartTime: "",
      targetExceptionEndTime: "",
      targetExceptionDaysOfWeek: [],
      targetContractDisplayMethod: CONTRACT_DISPLAY_METHOD.AUTO,
      skillErrorMessage: "",
      operatorSkills: this.props.operatorSkills,
      showAddSkillSection: false,
      showUpdateSkillSection: false,
      operatorSkillIndexToEdit: "",
      showDeleteConfirmationModalOperatorSkill: false,
      deleteIndexOperatorSkill: null,
      deleteOperatorSkillName: null,
      operatorExclusiveRecordingControl: this.props.operatorExclusiveRecordingControl 
        ? this.props.operatorExclusiveRecordingControl.isEnable // || false 
        : false,
      ringtoneLoopEnabled: this.props.ringtoneLoopEnabled
        ? this.props.ringtoneLoopEnabled.isEnable
        : false,
      disableInitiatingCoBrowse: this.props.disableInitiatingCoBrowse ? this.props.disableInitiatingCoBrowse.isEnable || false : false,
      disableCanvasDownload: this.props.disableCanvasDownload ? this.props.disableCanvasDownload.isEnable || false : false,
      enableVideoBlur: this.props.enableVideoBlur ? this.props.enableVideoBlur.isEnable || false : false,
      isPreviewResize: this.props.isPreviewResize ? this.props.isPreviewResize.isEnable || false : false,
      // inbound coBrowse settings
      inbShowCoBrowseContent : this.props.inbShowCoBrowseContent ? (this.props.inbShowCoBrowseContent.isEnable ? true : false) : false,
      inbGetSelectors:  [], 
      inbIsMaskingEnabled : this.props.inbIsMaskingEnabled ? (this.props.inbIsMaskingEnabled.isEnable ? true : false) : false,
      inbConsentMessage: this.props.inbConsentMessage && this.props.inbConsentMessage.message ? this.props.inbConsentMessage.message  : "",
      showCSSelectorAdd: false,
      showSelectorDelete: false,
      cssItemDelete: '',
      universalLinks: this.getUniversalLinksFromProps(this.props.universalLinks),
      universalLinksEnabled: this.props.universalLinksEnabled ? (this.props.universalLinksEnabled.isEnable ? true : false) : false,
      showUniversalLinkAdd: false,
      showUniversalLinkDelete: false,
      universalLinkItemDelete: '',
      // UI Guest Settings
      uiGuestSettingsRotation: 0,
      isUIGuestSettingsToggler: false,
      setTexts: this.getSetTextsFromProps(this.props.setTexts) || [],
      setTextEnabled: this.props.setTextEnabled ? (this.props.setTextEnabled.isEnable ? true : false) : false,
      showSetTextAdd: false,
      showSetTextDelete: false,
      setTextItemDelete: '',
      setTextIndexToDelete: null,
    };
  }

  getUniversalLinksFromProps = (universalLinksData) => {
    if (!universalLinksData) return [];
    
    // Handle object format with array values: {["url1", "url2", ...]}
    if (typeof universalLinksData === 'object' && !Array.isArray(universalLinksData)) {
      const firstValue = Object.values(universalLinksData)[0];
      return Array.isArray(firstValue) ? firstValue : [];
    }
    return Array.isArray(universalLinksData) ? universalLinksData : [];
  }

  getSetTextsFromProps = (setTextsData) => {
    if (!setTextsData) return [];
    if (typeof setTextsData === 'object' && !Array.isArray(setTextsData) && setTextsData.setTexts) {
      return Array.isArray(setTextsData.setTexts) ? setTextsData.setTexts : [];
    }
    if (Array.isArray(setTextsData)) {
      return setTextsData;
    }
    return [];
  }

  componentDidMount() {
    this.selectDefaultStorage(-1, STORAGE.RECORDING_STORAGE);
    this.selectDefaultStorage(-1, STORAGE.STORAGE);
    this.initSSODetails();
    this.initBandWidthSettings();
    if (this.props.inbGetSelectors && this.props.inbGetSelectors.selectors && this.props.inbGetSelectors.selectors.length > 0) {
      this.setState({ inbGetSelectors: this.props.inbGetSelectors.selectors });
    }
    // Universal links already initialized in constructor via helper method
  }

  componentDidUpdate(prevProps) {
    // Update universalLinks when props change
    if (this.props.universalLinks !== prevProps.universalLinks) {
      this.setState({ universalLinks: this.getUniversalLinksFromProps(this.props.universalLinks) });
    }
    
    // Update inbGetSelectors when props change
    if (this.props.inbGetSelectors !== prevProps.inbGetSelectors) {
      const selectors = this.props.inbGetSelectors?.selectors || [];
      this.setState({ inbGetSelectors: selectors });
    }

    // Update setTexts when props change
    if (this.props.setTexts !== prevProps.setTexts) {
      const propsSetTexts = this.getSetTextsFromProps(this.props.setTexts);
      this.setState({ setTexts: propsSetTexts !== null ? propsSetTexts : [] });
    }
    
    // Update inbGetSelectors when props change
    if (this.props.inbGetSelectors !== prevProps.inbGetSelectors) {
      const selectors = this.props.inbGetSelectors?.selectors || [];
      this.setState({ inbGetSelectors: selectors });
    }
  }

  resetStateToPrevState = () => {
    this.resetStorageDetailsFields();
    this.initSSODetails();
    this.initBandWidthSettings();
    this.resetError();
    if(this.ssoLocator) {  this.onDownArrowClicked(LOCATOR.SSO) }
    if(this.storageLocator) {  this.onDownArrowClicked(LOCATOR.STORAGE) }
    if(this.state.isCobrowseToggler) { this.onDownArrowClicked(LOCATOR.CO_BROWSE) }
    if(this.state.isInboudCobrowseToggler) {this.onDownArrowClicked(LOCATOR.INBOUND_CO_BROWSE)}
    if(this.state.isUIGuestSettingsToggler) {this.onDownArrowClicked(LOCATOR.UI_GUEST_SETTINGS)}
    if(this.emailListLocator) {  this.onDownArrowClicked(LOCATOR.EMAIL_LIST) }
    this.setState({
      allowedDownloads: _.cloneDeep(this.props.allowedDownloads) || {},
      subModulesScreenshare: _.cloneDeep(this.props.subModulesScreenshare) || {},
      subModulesAudioVideo: _.cloneDeep(this.props.subModulesAudioVideo) || {},
      subModulesCoBrowse: _.cloneDeep(this.props.subModulesCoBrowse) || {},
      subModulesSnapShot: _.cloneDeep(this.props.subModulesSnapShot) || {},
      subLoggingLevels: this.props.availableSubLoggingLevels ? _.cloneDeep(this.props.availableSubLoggingLevels) : [...defaultSubLoggingLevels],
      SSODetails: this.props.SSODetails ? _.cloneDeep(this.props.SSODetails) : {},
      storageDetails: this.props.storageDetails ? _.cloneDeep(this.props.storageDetails) : {},
    });
  };

  initBandWidthSettings = () => {
    if(this.state.bandwidthSettings && this.state.bandwidthSettings.length > 0 ) {
      this.state.bandwidthSettings.forEach(bandwidthElement => {
        if(bandwidthElement.module === Modules.AUDIO_VIDEO) {
          this.setState({
            videoStreamBandwidth: bandwidthElement.bandwidth ? bandwidthElement.bandwidth : "0", 
            videoStreamFPS: bandwidthElement.fps ? bandwidthElement.fps : DEFAULT_FPS,
            videoStreamCustomSize :
              this.props.customBandwidthAUDIO_VIDEO ? this.props.customBandwidthAUDIO_VIDEO.size || BANDWIDTH_CUSTOM_SIZE_DEFAULT : BANDWIDTH_CUSTOM_SIZE_DEFAULT,
            videoStreamCustomBitrate:
              this.props.customBandwidthAUDIO_VIDEO && typeof this.props.customBandwidthAUDIO_VIDEO.bitrate == 'number' && this.props.customBandwidthAUDIO_VIDEO.bitrate >= 0 ?
                this.props.customBandwidthAUDIO_VIDEO.bitrate : BANDWIDTH_CUSTOM_BITRATE_DEFAULT,
          });
        } else if(bandwidthElement.module === Modules.SCREENSHARE) {
          this.setState({
            screenShareBandwidth: bandwidthElement.bandwidth ? bandwidthElement.bandwidth : "0",
            screenShareFPS: bandwidthElement.fps ? bandwidthElement.fps : DEFAULT_FPS,
            screenShareCustomSize:
              this.props.customBandwidthSCREENSHARE ? this.props.customBandwidthSCREENSHARE.size || BANDWIDTH_CUSTOM_SIZE_DEFAULT : BANDWIDTH_CUSTOM_SIZE_DEFAULT,
            screenShareCustomBitrate:
              this.props.customBandwidthSCREENSHARE && typeof this.props.customBandwidthSCREENSHARE.bitrate == 'number' && this.props.customBandwidthSCREENSHARE.bitrate >= 0 ?
                this.props.customBandwidthSCREENSHARE.bitrate : BANDWIDTH_CUSTOM_BITRATE_DEFAULT,
          });
        }
      })
    }
  }

  initSSODetails = () => {
    if (this.state.SSODetails.isSSOEnabled) {
      this.setState({
        clientId: this.state.SSODetails.clientId ? this.state.SSODetails.clientId : "",
        cognitoDomain: this.state.SSODetails.cognitoDomain ? this.state.SSODetails.cognitoDomain : "",
        identityProvider: this.state.SSODetails.identityProvider ? this.state.SSODetails.identityProvider : "",
        clientSecret :this.state.SSODetails.clientSecret ? this.state.SSODetails.clientSecret : "" ,        
        userPoolId :this.state.SSODetails.userPoolId ? this.state.SSODetails.userPoolId : ""
      });
    }
  }

  // collapsible state maintainer / Accordion
  onDownArrowClicked = (locator) => {
    this.setState(
      {
        isArrowDownClicked: !this.state.isArrowDownClicked,
      },
      () => {
        if (locator === LOCATOR.SSO) {
          this.ssoLocator = !this.ssoLocator;
          setTimeout(() =>
            this.setState({
              isSSOToggler: !this.state.isSSOToggler,
              ssoRotation: this.ssoLocator ? 180 : 0,
            }))
        } else if(locator === LOCATOR.CO_BROWSE) {
          setTimeout(() =>
            this.setState((prevState) => ({
              isCobrowseToggler: !prevState.isCobrowseToggler,
              cobrowseRotation: !prevState.isCobrowseToggler ? 180 : 0,
            })))
        } else if(locator === LOCATOR.EMAIL_LIST) {
          this.emailListLocator = !this.emailListLocator;
          setTimeout(() =>
            this.setState((prevState) => ({
              isEmailListToggler: !prevState.isEmailListToggler,
              emailListRotation: !prevState.isEmailListToggler ? 180 : 0,
            }))
          );
        } else if (locator === LOCATOR.SUPPORT_CENTER) {
          setTimeout(() =>
            this.setState((prevState) => ({
              isSupportCenterToggler: !prevState.isSupportCenterToggler,
            }))
          );
        } else if (locator === LOCATOR.INBOUND_CO_BROWSE) {
          setTimeout(() =>
            this.setState((prevState) => ({
              isInboudCobrowseToggler: !prevState.isInboudCobrowseToggler,
              inboundCobrowseRotation: !prevState.inboundCobrowseRotation ? 180 : 0,
            }))
          );
        } else if (locator === LOCATOR.UI_GUEST_SETTINGS) {
          setTimeout(() =>
            this.setState((prevState) => ({
              isUIGuestSettingsToggler: !prevState.isUIGuestSettingsToggler,
              uiGuestSettingsRotation: !prevState.uiGuestSettingsRotation ? 180 : 0,
            }))
          );
        }
        else {
          // this.storageLocator = !this.storageLocator;
          setTimeout(() =>
            this.setState((prevState) => {
              return {
                [locator]: {
                  ...prevState[locator],
                  isStorageToggler: !prevState[locator].isStorageToggler,
                  storageRotation: !prevState[locator].storageRotation ? 180 : 0,
                }
              };}
            )
          )
        }
      }
    );
  };

  resetStorageDetailsFields = (targetStorage) => {
    this.setState({
      [targetStorage]: {
        ...this.state[targetStorage],
        isVerified: false,
        isAddStorage: false,
        isEditStorage: false,
        bucketName: "",
        id: "",
        secret: "",
        storageChanged: false,
        currentBucket: ""
      },
    },);
  }

  isValidDetails = () => {
    let valid = true;    
    if ((!this.state.cognitoDomain && !this.state.clientId && !this.state.identityProvider && !this.state.clientSecret && !this.state.userPoolId) || 
    (this.state.cognitoDomain && this.state.clientId && this.state.identityProvider && this.state.clientSecret && this.state.userPoolId)) {
      valid = true;
    } else {
      this.setState({ ssoErrorMessage: getMessage("EMPTY_MESSAGE") });
      valid = false;
    }

    if (this.state.storage.storageErrorMessage && !this.state.storage.isStorageToggler) {
      this.onDownArrowClicked(LOCATOR.STORAGE)
      valid = false;
    }
    if (this.state.recordingStorage.storageErrorMessage && !this.state.recordingStorage.isStorageToggler) {
      this.onDownArrowClicked(LOCATOR.RECORDING_STORAGE)
      valid = false;
    }

    if (!valid) {
      if (!this.state.ssoRotation) {
        this.onDownArrowClicked(LOCATOR.SSO)
      }
    }
    
    if (this.state.customUrlLabels && this.state.customUrlLabels[0] &&
      checkEmpty(this.state.customUrlLabels[0].label.trim())) {
      this.setState({
        customUrlLabelError: getMessage("ERR_EMPTY_CUSTOM_URL_LABEL")
      })
      if (!this.state.cobrowseRotation) {
        this.onDownArrowClicked(LOCATOR.CO_BROWSE)
      }
      valid = false
    }

    if(!this.state.inboundCobrowseRotation) {
      this.onDownArrowClicked(LOCATOR.INBOUND_CO_BROWSE)
    }

    if (!this.state.emailListLocator) {
      this.onDownArrowClicked(LOCATOR.EMAIL_LIST);
    }

    return valid;
  }

  handleSaveClick = () => {
    // email ids validation starts
    let allEmails = [];
    let allEmailsToCompare = [];
    if (this.state.concurrentSessionThreshold > 0 && checkEmpty(this.state.emailIds.trim())) {
      this.setState({ emailErrorMessage: getMessage("EMAIL_REQUIRED") });
      this.scrollToTop();
      return false;
    } else if (this.state.emailIds && this.state.emailIds.trim().length > 0) {
      let separators = [",", ";"];
      let arrayOfEmailIds = this.state.emailIds.split(new RegExp(separators.join("|"), "g"));
      let { arrayOfEmails, arrayOfPhone } = separatePhoneNumberAndEmails(arrayOfEmailIds);
      if (arrayOfPhone.length > 0 && arrayOfPhone[0] !== "") {
        this.setState({ emailErrorMessage: getMessage("VALID_EMAIL"), });
        this.scrollToTop();
        return false;
      }
      if (arrayOfEmails.length > 10) {
        this.setState({ emailErrorMessage: getMessage("EMAIL_LIMIT_VALIDATION"), });
        this.scrollToTop();
        return false;
      }
      for (let i = 0; i < arrayOfEmails.length; i++) {
        let email = arrayOfEmails[i];
        let isValidEmail = validator.isEmail(email);
        if (!isValidEmail) {
          this.setState({ emailErrorMessage: getMessage("VALID_EMAIL"), });
          this.scrollToTop();
          return false;
        } 
        allEmails.push({ email });
        allEmailsToCompare.push(email);
      }
    }
    // email ids validation ends
    // password validation starts
    if (this.state.newRecordingPassword || this.state.confirmRecordingPassword) {
      if (!this.state.newRecordingPassword) {
        this.setState({ recordingPasswordErrorMessage: getMessage("ENTER_NEW_PASSWORD"), });
        this.scrollToTop();
        return false;
      } else if (!this.state.confirmRecordingPassword) {
        this.setState({ recordingPasswordErrorMessage: getMessage("ENTER_CONFIRM_PASSWORD"), });
        this.scrollToTop();
        return false;
      } else {
        let errorMessage = validateSetRecordingPassword(
          this.state.newRecordingPassword,
          this.state.confirmRecordingPassword
        )
        if (errorMessage) {
          this.setState({ recordingPasswordErrorMessage: errorMessage, });
          this.scrollToTop();
          return false;
        }
      }
    }
    // password validation ends
    // recording storage validation starts
    if (this.props.availableModules.includes("RECORDING")
      && this.state.recordingStorage.storageDetails?.location === STORAGE_LOCATION.CUSTOMER
      && this.state.recordingStorage.storageDetails.list.length > 0) {
      let storageSelectedFlag = false;
      this.state.recordingStorage.storageDetails.list.forEach((storageDetail) => {
        if (storageDetail.isSelected) {
          storageSelectedFlag = true;
        }
      })
      if (!storageSelectedFlag) {
        this.setState((prevState) => {
          return {
            recordingStorage: {
              ...prevState.recordingStorage,
              saveStorageErrorMessage: getMessage("INVALID_STORAGE_OPTION"),
            }
          }
        });
        if (!this.state.recordingStorage.isStorageToggler) {
          this.onDownArrowClicked(LOCATOR.RECORDING_STORAGE)
        }
        this.scrollToTop();
        return false;
      }
    }
    // recording storage validation ends
    if (this.isValidDetails()) {
      let SSODetails = {
        ...this.state.SSODetails,
        cognitoDomain: this.state.cognitoDomain ? this.state.cognitoDomain : "",
        clientId: this.state.clientId ? this.state.clientId : "",
        identityProvider: this.state.identityProvider ? this.state.identityProvider : "",
        clientSecret: this.state.clientSecret ? this.state.clientSecret : "",
        userPoolId: this.state.userPoolId ? this.state.userPoolId : ""
      }

      // need to set blank sso details to null to compare with props as props has null values
      // TODO: server should accept null SSO details as its sending null values in get API
      const ssoDetailsToCompare = {
        ...this.state.SSODetails,
        cognitoDomain: this.state.cognitoDomain ? this.state.cognitoDomain : null,
        clientId: this.state.clientId ? this.state.clientId : null,
        identityProvider: this.state.identityProvider ? this.state.identityProvider : null,
        clientSecret: this.state.clientSecret ? this.state.clientSecret : null,
        userPoolId: this.state.userPoolId ? this.state.userPoolId : null
      }

      let bandwidthSettings = [];
      let customBandwidthAUDIO_VIDEO = {};
      let customBandwidthSCREENSHARE = {};
      if (this.props.isVideoOrSnapshotSelected) {
        bandwidthSettings.push({
          module: Modules.AUDIO_VIDEO,
          bandwidth: this.state.videoStreamBandwidth,
          fps: this.state.videoStreamFPS,
        });
        if (this.state.videoStreamBandwidth == BANDWIDTH_CUSTOM) {
          customBandwidthAUDIO_VIDEO.size = this.state.videoStreamCustomSize;
          customBandwidthAUDIO_VIDEO.bitrate = this.state.videoStreamCustomBitrate;
        }
      }

      if (this.props.isScreenShareSelected) {
        bandwidthSettings.push({
          module: Modules.SCREENSHARE,
          bandwidth: this.state.screenShareBandwidth,
          fps: this.state.screenShareFPS,
        });
        if (this.state.screenShareBandwidth == BANDWIDTH_CUSTOM) {
          customBandwidthSCREENSHARE.size = this.state.screenShareCustomSize;
          customBandwidthSCREENSHARE.bitrate = this.state.screenShareCustomBitrate;
        }
      }

      let userNotifySetting = {
        passwordChangeCompleted: this.state.notifyPasswordChangeCompleted,
        qrCode: this.state.notifyQRCode,
      };

      let isEntryAllowed = {
        isEnable: this.state.isEntryAllowed,
      };

      let isHorizontalDisplayFixed = {
        isEnable: this.state.horizontalDisplayFixed,
      };

      let disableCanvasEdit = {
        isEnable: this.state.disableCanvasEdit,
      };

      let disableIcsFile = {
        isEnable: this.state.disableIcsFile,
      };

      let isDisableInitiatingCoBrowse = {
        isEnable: this.state.disableInitiatingCoBrowse,
      };

      let disableCanvasDownload = {
        isEnable: this.state.disableCanvasDownload,
      };

      // List of Emails
      let userInventMsgCustomize = {
        isEnable: this.state.isUserInventMsgCustomizeEnable,
        emailAddresses: this.state.emailAddresses,
      };

      // List of Emails
      let screenMaskSetting = {
        mode: this.state.screenMaskMode,
      };

      let reductionLogs = {
        isEnable: this.state.isReductionLogs,
      };

      let operatorExclusiveRecordingControl = {
        isEnable: this.state.operatorExclusiveRecordingControl,
      };

      let ringtoneLoopEnabled = {
        isEnable: this.state.ringtoneLoopEnabled,
      };

      let enableVideoBlur = {
        isEnable: this.state.enableVideoBlur,
      };

      let isPreviewResize = {
        isEnable: this.state.isPreviewResize,
      };

      let storageDetails = this.state.storage.storageDetails;
      let recordingStorageDetails = this.state.recordingStorage.storageDetails;
      let cobrowseSettings = _.cloneDeep(this.state.cobrowseSettings);

      let inbIsMaskingEnabled = {
        isEnable: this.state.inbIsMaskingEnabled,
      }
  
      let inbCSSelectors = {
        selectors: this.state.inbGetSelectors,
      }

      let universalLinksEnabled = {
        isEnable: this.state.universalLinksEnabled,
      }

      let setTextEnabled = { 
        isEnable: this.state.setTextEnabled,
      };

      // Co-Browse start
      cobrowseSettings.mutualEdit = this.state.mutualEdit;

      cobrowseSettings.customUrlLabels = this.state.allowCustomUrl === false ? [] : this.state.customUrlLabels;
      cobrowseSettings.allowCustomUrl = this.state.allowCustomUrl;
      cobrowseSettings.targetSites = _.cloneDeep(this.state.targetSites);
      if (cobrowseSettings.targetSites) {
        cobrowseSettings.targetSites.forEach((item, index, arr) => {
          if (item.url) {
            cobrowseSettings.targetSites[index].url = Buffer.from(item.url).toString('base64');
          }
        });
      }
      delete cobrowseSettings.cobrowseType;
      storageDetails.list = storageDetails.location === STORAGE_LOCATION.CUSTOMER 
        ? storageDetails?.list.slice() : [];
      recordingStorageDetails.list = recordingStorageDetails.location === STORAGE_LOCATION.CUSTOMER
        ? recordingStorageDetails?.list.slice() : [];
      const availableSubModulesValue = Object.assign({}, this.state.allowedDownloads, this.state.subModulesScreenshare, 
        this.state.subModulesAudioVideo, this.state.subModulesCoBrowse,this.state.subModulesSnapShot);
      let details = {
        storageDetails: storageDetails,
        recordingStorageDetails: recordingStorageDetails, 
        SSODetails: SSODetails,
        subLoggingLevels: this.state.subLoggingLevels,
        availableSubModules: availableSubModulesValue,
        concurrentSessionThreshold: this.state.concurrentSessionThreshold ? this.state.concurrentSessionThreshold : 0,
        businessModel: this.props.concurrentSessionData.businessModel,
        concurrentSessionNotifyEmails: allEmails,
        cobrowseSettings: cobrowseSettings,
        maxSmsSend: this.state.maxSmsSend,
        recordingMethod: this.state.recordingMethod,
        recordingTarget: this.state.recordingTarget,
        modalRecordingMessage: this.state.modalRecordingMessage,
        audioRecordingMessage: this.state.audioRecordingMessage,
        videoRecordingMessage: this.state.videoRecordingMessage,
        recordingRetentionPeriod: this.state.retentionPeriod,
        recordingPassword: this.state.newRecordingPassword,
        userNotifySetting,
        userInventMsgCustomize,
        passwordLength: this.state.passwordLength,
        useUpper: this.state.useUpper,
        useLower: this.state.useLower,
        useNumber: this.state.useNumber,
        useSpecialChar: this.state.useSpecialChar,
        pastPasswordLimit: this.state.pastPasswordLimit,
        screenMaskSetting,
        isEntryAllowed,
        reductionLogs,
        isHorizontalDisplayFixed,
        disableCanvasEdit,
        disableIcsFile,
        operatorSkills: this.state.operatorSkills,
        operatorExclusiveRecordingControl,
        ringtoneLoopEnabled,
        isDisableInitiatingCoBrowse,
        disableCanvasDownload,
        enableVideoBlur,
        isPreviewResize,
        inbIsMaskingEnabled,
        inbCSSelectors,
        universalLinksEnabled,
        universalLinks: {universalLinks: this.state.universalLinks},
        setTexts: {setTexts: this.state.setTexts},
        setTextEnabled: setTextEnabled,
      }

      if (bandwidthSettings.length > 0) {
        details.bandwidthSettings = bandwidthSettings;
        if (customBandwidthAUDIO_VIDEO.size ) {
          details.customBandwidthAUDIO_VIDEO = customBandwidthAUDIO_VIDEO;
        }
        if (customBandwidthSCREENSHARE.size ) {
          details.customBandwidthSCREENSHARE = customBandwidthSCREENSHARE;
        }
      }

      if (this.state.senderId.length < 3 || !isNaN(this.state.senderId) || !this.state.senderId.match(/^[A-Za-z0-9]+$/)) {
        this.setState({ senderIdErrorMessage: getMessage("VALID_SENDER_ID"), });
        return false;
      } else {
        details.senderId = this.state.senderId;
      }

      let policyNumCheck = 0;
      [details.useUpper, details.useLower, details.useNumber, details.useSpecialChar].forEach(
        (policy) => { if (policy) { policyNumCheck += 1; }}
      );
      if (policyNumCheck < passwordPolicyNum) {
        this.setState({ policyErrorMessage: getMessage("VALID_PW_POLICIES") });
        let passwordPolicyElement = document.getElementById("passwordPolicy");
        passwordPolicyElement && passwordPolicyElement.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "nearest"
        });
        return false;
      }
      
      allEmailsToCompare = allEmailsToCompare.length > 0 ? allEmailsToCompare : null;

      if (!_.isEqual(this.state.allowedDownloads, this.props.allowedDownloads)
        || !_.isEqual(this.state.subModulesScreenshare, this.props.subModulesScreenshare)
        || !_.isEqual(this.state.subModulesAudioVideo, this.props.subModulesAudioVideo)
        || !_.isEqual(this.state.subModulesCoBrowse, this.props.subModulesCoBrowse)
        || !_.isEqual(this.state.subModulesSnapShot, this.props.subModulesSnapShot)
        || !_.isEqual(this.state.subLoggingLevels, this.props.availableSubLoggingLevels)
        || !_.isEqual(this.state.storage.storageDetails, this.props.storageDetails)
        || !_.isEqual(this.state.recordingStorage.storageDetails, this.props.recordingStorageDetails)
        || !_.isEqual(ssoDetailsToCompare, this.props.SSODetails)
        || !_.isEqual(bandwidthSettings, this.props.bandwidthSettings)
        || !_.isEqual(customBandwidthAUDIO_VIDEO, this.props.customBandwidthAUDIO_VIDEO)
        || !_.isEqual(customBandwidthSCREENSHARE, this.props.customBandwidthSCREENSHARE)
        || !_.isEqual( this.state.concurrentSessionThreshold, this.props.concurrentSessionData.concurrentSessionThreshold)
        || !_.isEqual( allEmailsToCompare, this.props.concurrentSessionData.concurrentSessionNotifyEmails)
        || !_.isEqual(this.state.allowCustomUrl, this.props.cobrowseSettings.allowCustomUrl)
        || !_.isEqual(this.state.targetSites, this.props.cobrowseSettings.targetSites)
        || !_.isEqual(this.state.customUrlLabels, this.props.cobrowseSettings.customUrlLabels)
        || !_.isEqual(this.state.maxSmsSend, this.props.concurrentSessionData.maxSmsSend)
        || !_.isEqual(this.state.recordingMethod, this.props.recordingMethod)
        || !_.isEqual(this.state.recordingTarget, this.props.recordingTarget)
        || !_.isEqual(this.state.modalRecordingMessage, this.props.modalRecordingMessage)
        || !_.isEqual(this.state.audioRecordingMessage, this.props.audioRecordingMessage)
        || !_.isEqual(this.state.videoRecordingMessage, this.props.videoRecordingMessage)
        || !_.isEqual(this.state.retentionPeriod, this.props.retentionPeriod)
        || this.state.newRecordingPassword
        || !_.isEqual(this.state.senderId, this.props.concurrentSessionData.sender_id)
        || !_.isEqual(this.state.mutualEdit, this.props.cobrowseSettings.mutualEdit)
        || !_.isEqual(userNotifySetting, this.props.userNotifySetting)
        || !_.isEqual(userInventMsgCustomize, this.props.userInventMsgCustomize)
        || !_.isEqual(this.state.passwordLength, this.props.concurrentSessionData.password_length)
        || !_.isEqual(this.state.useUpper, this.props.concurrentSessionData.use_pw_uppercase)
        || !_.isEqual(this.state.useLower, this.props.concurrentSessionData.use_pw_lowercase)
        || !_.isEqual(this.state.useNumber, this.props.concurrentSessionData.use_pw_number)
        || !_.isEqual(this.state.useSpecialChar, this.props.concurrentSessionData.use_pw_special_char)
        || !_.isEqual(this.state.pastPasswordLimit, this.props.concurrentSessionData.check_past_password)
        || !_.isEqual(screenMaskSetting, this.props.screenMaskSetting)
        || !_.isEqual(isEntryAllowed, this.props.isEntryAllowedSettings)
        || !_.isEqual(isHorizontalDisplayFixed, this.props.horizontalDisplayFixedSettings)
        || !_.isEqual(this.state.operatorSkills, this.props.operatorSkills)
        || !_.isEqual(disableCanvasEdit, this.props.disableCanvasEdit)
        || !_.isEqual(disableIcsFile, this.props.disableIcsFile)
        || !_.isEqual(operatorExclusiveRecordingControl, this.props.operatorExclusiveRecordingControl)
        || !_.isEqual(ringtoneLoopEnabled, this.props.ringtoneLoopEnabled)
        || !_.isEqual(isDisableInitiatingCoBrowse, this.props.disableInitiatingCoBrowse)
        || !_.isEqual(disableCanvasDownload, this.props.disableCanvasDownload)
        || !_.isEqual(enableVideoBlur, this.props.enableVideoBlur)
        || !_.isEqual(isPreviewResize, this.props.isPreviewResize)
        || !_.isEqual(inbIsMaskingEnabled, this.props.inbIsMaskingEnabled)
        || !_.isEqual(inbCSSelectors, this.props.inbGetSelectors)
        || !_.isEqual(universalLinksEnabled, this.props.universalLinksEnabled)
        || !_.isEqual(this.state.universalLinks, this.getUniversalLinksFromProps(this.props.universalLinks))
        || !_.isEqual(setTextEnabled, this.props.setTextEnabled)
        || !_.isEqual(this.state.setTexts, this.getSetTextsFromProps(this.props.setTexts))
      ) {
        this.props.updateCustomerSettings(details, (error) => {
          if (!error) {
            this.resetStorageDetailsFields(STORAGE.STORAGE);
            this.resetError(STORAGE.STORAGE);
            this.resetStorageDetailsFields(STORAGE.RECORDING_STORAGE);
            this.resetError(STORAGE.RECORDING_STORAGE);
            if (this.ssoLocator) { this.onDownArrowClicked(LOCATOR.SSO) }
            if (this.storageLocator) { this.onDownArrowClicked(LOCATOR.STORAGE) }
            if (this.state.isCobrowseToggler) { this.onDownArrowClicked(LOCATOR.CO_BROWSE) }
            if (this.emailListLocator) { this.onDownArrowClicked(LOCATOR.EMAIL_LIST) }
            if (this.state.isSupportCenterToggler) { this.onDownArrowClicked(LOCATOR.SUPPORT_CENTER) }
            if (this.state.isInboudCobrowseToggler) { this.onDownArrowClicked(LOCATOR.INBOUND_CO_BROWSE) }
          } else if (error.code === ERROR.NOT_RECORDING_PASSWORD) {
            this.setState({ recordingPasswordErrorMessage: getMessage(ERROR.NOT_RECORDING_PASSWORD) });
          }
        })
      } else if (this.state.storageErrorMessage || this.state.ssoErrorMessage) {
        if (this.ssoLocator) {
          this.onDownArrowClicked(LOCATOR.SSO);
        }
        if (this.storageLocator) {
          this.onDownArrowClicked(LOCATOR.STORAGE);
        }
      } else {
        this.resetStorageDetailsFields(STORAGE.STORAGE);
        this.resetError(STORAGE.STORAGE);
        this.resetStorageDetailsFields(STORAGE.RECORDING_STORAGE);
        this.resetError(STORAGE.RECORDING_STORAGE);
        this.props.handleCancelClick();
      }
    }
  }

  // scrollToTop method use to scroll page on top when user is getting error for email or threshold
  scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }

  updateAvailableDownloads = (allow, downloadableSubModule) => {
    if (allow) {
      if (!this.state.allowedDownloads || !this.state.allowedDownloads.hasOwnProperty(downloadableSubModule)) {
        let allowedDownloads = this.state.allowedDownloads
        allowedDownloads[downloadableSubModule] = null
        this.setState({
          allowedDownloads: allowedDownloads
        })
      }
    } else {
      if (this.state.allowedDownloads && this.state.allowedDownloads.hasOwnProperty(downloadableSubModule)) {
        let allowedDownloads = this.state.allowedDownloads
        delete allowedDownloads[downloadableSubModule]
        this.setState({
          allowedDownloads: allowedDownloads
        })
      }
    }
  }

  updateScreenShare = (allow, subModule) => {
    if (allow) {
      if (!this.props.isScreenShareSelected || !this.state.subModulesScreenshare.hasOwnProperty(subModule)) {
        let subModulesScreenshare = this.state.subModulesScreenshare
        subModulesScreenshare[subModule] = null
        this.setState({
          subModulesScreenshare: subModulesScreenshare
        })
      }
    } else {
      if (this.props.isScreenShareSelected && this.state.subModulesScreenshare.hasOwnProperty(subModule)) {
        let subModulesScreenshare = this.state.subModulesScreenshare
        delete subModulesScreenshare[subModule]
        this.setState({
          subModulesScreenshare: subModulesScreenshare
        })
      }
    }
  }

  updateAudioVideo = (allow, subModule) => {
    if (allow) {
      if (!this.props.isVideoSelected || !this.state.subModulesAudioVideo.hasOwnProperty(subModule)) {
        let subModulesAudioVideo = this.state.subModulesAudioVideo
        subModulesAudioVideo[subModule] = null
        this.setState({
          subModulesAudioVideo
        })
      }
    } else {
      if (this.props.isVideoSelected && this.state.subModulesAudioVideo.hasOwnProperty(subModule)) {
        let subModulesAudioVideo = this.state.subModulesAudioVideo
        delete subModulesAudioVideo[subModule]
        this.setState({
          subModulesAudioVideo
        })
      }
    }
  }

  updateConfirmScreen = (allow, subModule) => {
    if (allow) {
      if (!this.props.isScreenShareSelected || !this.state.subModulesScreenshare.hasOwnProperty(subModule)) {
        let subModulesScreenshare = this.state.subModulesScreenshare
        subModulesScreenshare[subModule] = null
        this.setState({
          subModulesScreenshare: subModulesScreenshare
        })
      }
    } else {
      if (this.props.isScreenShareSelected && this.state.subModulesScreenshare.hasOwnProperty(subModule)) {
        let subModulesScreenshare = this.state.subModulesScreenshare
        delete subModulesScreenshare[subModule]
        this.setState({
          subModulesScreenshare: subModulesScreenshare
        })
      }
    }
  }

  updateFixedBrowse = (allow, subModule) => {
    if (allow) {
      if (!this.props.isCoBrowseSelected || !this.state.subModulesCoBrowse.hasOwnProperty(subModule)) {
        let subModulesCoBrowse = this.state.subModulesCoBrowse
        subModulesCoBrowse[subModule] = null
        this.setState({
          subModulesCoBrowse: subModulesCoBrowse
        })
      }
    } else {
      if (this.props.isCoBrowseSelected && this.state.subModulesCoBrowse.hasOwnProperty(subModule)) {
        let subModulesCoBrowse = this.state.subModulesCoBrowse
        delete subModulesCoBrowse[subModule]
        this.setState({
          subModulesCoBrowse: subModulesCoBrowse
        })
      }
    }
  }

  updateSnapShot = (allow, subModule) => {
    if (allow) {
      if (!this.props.isSnapShotSelected || !this.state.subModulesSnapShot.hasOwnProperty(subModule)) {
        let subModulesSnapShot = this.state.subModulesSnapShot
        subModulesSnapShot[subModule] = null
        this.setState({
          subModulesSnapShot: subModulesSnapShot
        })
      }
    } else {
      if (this.props.isSnapShotSelected && this.state.subModulesSnapShot.hasOwnProperty(subModule)) {
        let subModulesSnapShot = this.state.subModulesSnapShot
        delete subModulesSnapShot[subModule]
        this.setState({
          subModulesSnapShot: subModulesSnapShot
        })
      }
    }
  }

  handleSubLoggingLevelsChanged = (event) => {
    let currentSubloggingLevels = this.state.subLoggingLevels
    if (event.target.checked && currentSubloggingLevels.indexOf(event.target.name) === -1) {
      currentSubloggingLevels.push(event.target.name)
    }
    else if (!event.target.checked && currentSubloggingLevels.includes(event.target.name) >= 0) {
      currentSubloggingLevels = _.remove(currentSubloggingLevels, item => {
        if (item !== event.target.name) return item;
      });
    }
    this.setState({ subLoggingLevels: currentSubloggingLevels });
  }

  resetError = (targetStorage) => {
    this.setState((state, props) => {
      return{
        [targetStorage]: {
          ...state[targetStorage],
          storageErrorMessage: "",
          saveStorageErrorMessage: "",
        },
        ssoErrorMessage: "",
        cobrowseURLError: "",
        skillErrorMessage: "",
      }
    });
  }

  handleInputChange = (event) => {
    if(!hasWhiteSpace(event.target.value)) {
      this.setState({ [event.target.name]: event.target.value.trim()});
      this.resetError();
    }
  }

  handleCoBrowseInputChange = (event) => {
    this.setState({ [event.target.name]: event.target.value});
    this.resetError();
  }
  handleRecordingInputChange = (event) => {
    this.setState({ [event.target.name]: event.target.value});
    this.resetError();
  }
  handleSupportCenterInputChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
    this.resetError();
  }
  handleSupportCenterNumericInputChange = (name, value, maxLimit) => {
    if (!Number.isInteger(value) || value > maxLimit) {
      this.setState({
        [name]: this.state[name]
      });
      this.resetError();
      return;
    }
    this.setState({
      [name]: value,
    });
    this.resetError();
  }
  handleSupportCenterReceptionHoursInputChange = (name, value) => {
    this.setState({ [name]: value });
    this.resetError();
  }
  handleSupportCenterCheckboxChange = (event) => {
    const name = event.target.name;
    this.setState((prevState) => ({
      [name]: !prevState[name],
    }));
    this.resetError();
  }
  handleSupportCenterExceptionDaysChange = (event) => {
    const changedDay = event.target.name;
    this.setState((prevState) => {
      if (prevState.targetExceptionDaysOfWeek.includes(changedDay)) {
        return {
          targetExceptionDaysOfWeek: prevState.targetExceptionDaysOfWeek.filter(
            (day) => day !== changedDay
          ),
        };
      } else {
        return { targetExceptionDaysOfWeek: [...prevState.targetExceptionDaysOfWeek, changedDay] };
      }
    });
    this.resetError();
  }
  handleCustomUrlInputChange = (event) => {
    let customUrlLabels =  this.state.customUrlLabels;
    if(event.target.value=="") {
      this.setState({ customUrlLabels: []})
    } else {
      if(!customUrlLabels.length) {
        customUrlLabels.push({label: event.target.value} );
        this.setState({
          customUrlLabels: customUrlLabels,
          customUrlLabelError: ""
        });
      } else {      
        customUrlLabels[0].label= event.target.value;
        this.setState({
          customUrlLabels : customUrlLabels,
          customUrlLabelError: ""
        });
      }    
    }
  }

  handleThresholdInputChange = (name, value, maxLimit) => {
    if (!Number.isInteger(value) || value > maxLimit) {
      this.setState({
        [name]: this.state[name]
      });
      this.resetError();
      return;
    }
    this.setState({
      [name]: value,
    });
    this.resetError();
  }

  handleMaxPassLenChange = (name, value, maxLimit) => {
    if (!Number.isInteger(value) || value > maxLimit) {
      this.setState({
        [name]: this.state[name]
      });
      return;
    }
    this.setState({
      [name]: value,
      errorMessage: "",
      isDataEdited: true
    });
  }

  pwPolicy = (name) => {
    let isChecked = "";
    if (name === passwordPolicy.UPPERCASE) {
      isChecked = this.state.useUpper;
    } else if (name === passwordPolicy.LOWERCASE) {
      isChecked = this.state.useLower;
    } else if (name === passwordPolicy.WITHNUMBER) {
      isChecked = this.state.useNumber;
    } else if (name === passwordPolicy.SPECIALCHAR) {
      isChecked = this.state.useSpecialChar;
    }
    return isChecked;
  }

  changePwPolicy = event => {
    let changePolicy = "";
    if (event.target.name === passwordPolicy.UPPERCASE) {
      changePolicy = passwordPolicyName[0];
    } else if (event.target.name === passwordPolicy.LOWERCASE) {
      changePolicy = passwordPolicyName[1];
    } else if (event.target.name === passwordPolicy.WITHNUMBER) {
      changePolicy = passwordPolicyName[2];
    } else if (event.target.name === passwordPolicy.SPECIALCHAR) {
      changePolicy = passwordPolicyName[3];
    }
    this.setState({
      [changePolicy]: event.target.checked,
      errorMessage: "",
      isDataEdited: true
    });
  }

  handleS3InputChange = (event, targetStorage) => {
    if (!hasWhiteSpace(event.target.value)) {
      this.setState({
        [targetStorage]:{
          ...this.state[targetStorage],
          [event.target.name]: event.target.value,
          isVerified: false
        }
      },() => {this.resetError(targetStorage)}
      );
    }
  }
  handleEmailInputChange = () => event => {
    this.setState({
      emailIds : event.target.value.replace(" ", "").trim(),
      emailErrorMessage: "",
    });
  };

  selectDefaultStorage = (selectedStorageDetailIndex, targetStorage) => {
    let storageDetailsList = this.state[targetStorage]?.storageDetails?.list
      ? this.state[targetStorage]?.storageDetails?.list.slice() 
      : [];
    let valid = false
    let storageState = _.cloneDeep(this.state[targetStorage]);
    if (selectedStorageDetailIndex != -1) {
      let newStorageDetailsList = storageDetailsList
      storageDetailsList.forEach((storageDetails, index) => {
        if (index === selectedStorageDetailIndex) {
          newStorageDetailsList[index].isSelected = true;
          valid = true;
          storageState.storageChanged = true;
          this.setState({
            isDataEdited: true
          })
        } else {
          newStorageDetailsList[index].isSelected = false;
        }
      });
      storageState.storageDetails.list = newStorageDetailsList;
    }
    else {
      storageDetailsList.forEach((storageDetails, index) => {
        if (storageDetails.isSelected) {
          valid = true;
        }
      });
    }
    this.setState({
      [targetStorage]: {
        ...storageState,
        isStorageSelected: valid,
        saveStorageErrorMessage: "",
      }
    });// storageDetails: obj
  }

  renderStorageDetailSetting = (targetStorage) => {
    return(
      <div className="section">
        <Row className="noMargin">
          <Col md={11} className="mainTitleStorage">{getMessage("STORAGE")}
          </Col>
          {
              this.state[targetStorage].storageDetails?.location === STORAGE_LOCATION.CUSTOMER ?
                <Col md={1}>
                  <img
                    style={{ transform: `rotate(${this.state[targetStorage ].storageRotation}deg)` }}
                    className="dropDown cursorPointer floatRight"
                    src={ic_arrow_down} 
                    alt="storagetoggler" 
                    id="storagetoggler"
                    onClick={() => this.onDownArrowClicked(targetStorage)} />
                </Col> : null}
        </Row>
        {
          this.state[targetStorage].storageDetails?.location === STORAGE_LOCATION.CUSTOMER ?
            <>
              <Collapse isOpen={this.state[targetStorage].isStorageToggler}>
                <Row>
                  {(!this.state[targetStorage].isAddStorage && !this.state[targetStorage ].isEditStorage)
                    && (this.state[targetStorage].storageDetails?.location === STORAGE_LOCATION.CUSTOMER) &&
                    <Col xs={12} className="mainTitleStorage">
                      {/* add stoage (+) */}
                      <img 
                        src={ic_add}
                        className="cursorPointer floatRight mr-3"
                        onClick={() => this.setState({
                          [targetStorage]: { 
                            ...this.state[targetStorage],
                            isAddStorage: true 
                          }
                        })}
                        data-toggle="tooltip"
                        data-placement="top"
                        title={getMessage("ADD_STORAGE")} />
                    </Col>
                  }
                </Row>
                {this.state[targetStorage].storageDetails.list &&
                  <Row className="storageCard">
                    <CardBody className="pt-0 pb-0">
                      <Row className="interCardContent">
                        <Table bordered size="sm" className="storageTableWidth">
                          <thead>
                            <tr className="storageHead">
                              <th className="storageRow border-bottom rounded"> </th>
                              <th className="storageRow border-bottom rounded" colSpan="2">{getMessage("BUCKET_NAME")}</th>
                              <th className="storageRow border-bottom rounded" colSpan="3">{getMessage("ID")}</th>
                              <th className="storageRow border-bottom rounded" colSpan="3">{getMessage("SECRET")}</th>
                              <th className="storageRow border-bottom rounded"> </th>
                              <th className="storageRow border-bottom rounded"> </th>
                            </tr>
                          </thead>
                          {this.renderStorageTableBody(targetStorage)}
                        </Table>
                      </Row>
                    </CardBody>
                  </Row>}
                {
                  (this.state[targetStorage].isEditStorage || this.state[targetStorage].isAddStorage) &&
                    <Row>
                      <Col className="storageCard">
                        <Card>
                          <CardBody>
                            <Row className="radio">
                              <Col className="mainTitleStorage">{getMessage("AWS_S3")}:</Col>
                              <Col>
                                {/* × button */}
                                <Button 
                                  close aria-label="Cancel"
                                  onClick={() => this.cancelStorage(targetStorage)}
                                  type="button"
                                >
                                </Button>
                              </Col>
                            </Row>
                            <Row className="interCardContent">
                              <Col xs={4} className="pt-2 align-self-center">
                                <Label>{getMessage("BUCKET_NAME")}</Label> </Col>
                              <Col xs={8}>
                                <Input
                                  type="text"
                                  name="bucketName"
                                  className="inputFormControl"
                                  maxLength="63"
                                  required
                                  disabled={this.state[targetStorage].currentBucket}
                                  onChange={(event) => this.handleS3InputChange(event, targetStorage)}
                                  value={this.state[targetStorage].bucketName}
                                />
                              </Col>
                            </Row>
                            <Row className="interCardContent">
                              <Col xs={4} className="pt-2 align-self-center">
                                <Label>
                                  {getMessage("ID")}
                                </Label>
                              </Col>
                              <Col xs={8}>
                                <Input
                                  type="text"
                                  name="id"
                                  className="inputFormControl"
                                  maxLength="50"
                                  required
                                  onChange={(event) => this.handleS3InputChange(event, targetStorage)}
                                  value={this.state[targetStorage].id}
                                />
                              </Col>
                            </Row>
                            <Row className="interCardContent">
                              <Col xs={4} className="pt-2 align-self-center">
                                <Label>
                                  {getMessage("SECRET")}
                                </Label>
                              </Col>
                              <Col xs={8}>
                                <Input
                                  type="password"
                                  name="secret"
                                  className="inputFormControl"
                                  maxLength="50"
                                  required
                                  onChange={(event) => this.handleS3InputChange(event, targetStorage)}
                                  value={this.state[targetStorage].secret}
                                />
                              </Col>
                            </Row>
                            {this.state[targetStorage].storageErrorMessage &&
                              <Row>
                                <Col md={12} className="errors autoHeight">
                                  {getMessage(this.state[targetStorage].storageErrorMessage)}
                                </Col>
                              </Row>
                            }
                            <Row className="interCardContent floatRight mx-2">
                              <Button 
                                onClick={() => this.handleVerifyStorageDetailsClick(targetStorage)}
                                disabled={!this.state[targetStorage].isVerified ? false : true}
                                className={this.state[targetStorage].isVerified ? "verifiedBtn mt-2 " : "verifyBtn mt-2"}
                                type="button"
                              >
                                {this.state[targetStorage].isVerified ? getMessage("VERIFIED") : getMessage("VERIFY")}
                              </Button>
                              <Button 
                                className={this.state[targetStorage].isVerified 
                                  ? "borderBtn cursorPointer bgwhite ml-3 mt-2" 
                                  : "disabledBtn ml-3 mt-2"}
                                disabled={this.state[targetStorage].isVerified ? false : true}
                                onClick={() => this.addStorage(targetStorage)}
                                type="button"
                              >
                                {this.state[targetStorage].isEditStorage ? getMessage("UPDATE") : getMessage("ADD")}
                              </Button>
                            </Row>
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                }
                {this.state[targetStorage].saveStorageErrorMessage &&
                  <Row>
                    <Col md={12} className="errors autoHeight">
                      {getMessage(this.state[targetStorage].saveStorageErrorMessage)}
                    </Col>
                  </Row>
                }
                {this.state[targetStorage].storageChanged &&
                  <Row>
                    <Col md={12} className="text-muted text-center autoHeight">
                      {targetStorage === STORAGE.STORAGE
                        ? getMessage("SECOND_LOOOKIT_CUSTOM_WARNING")
                        : getMessage("SECOND_LOOOKIT_CUSTOM_WARNING_RECORDING")}
                    </Col>
                  </Row>
                }
              </Collapse>
              {this.state[targetStorage].storageDetails?.location === STORAGE_LOCATION.CUSTOMER
              && !this.state[targetStorage].isStorageSelected
              && (!this.state[targetStorage].isEditStorage && !this.state[targetStorage].isAddStorage) &&
                <Row>
                  <Col md={12} className="warning autoHeight">
                    {targetStorage === STORAGE.RECORDING_STORAGE
                    && getMessage("FIRST_LOOOKIT_CUSTOM_WARNING_RECORDING")}
                  </Col>
                </Row>}
            </>:
            <Row className="pb-2">
              <Col xs={12}>
                <span className="ml-3">
                  {getMessage("MANAGED_BY_LOOOKIT")}
                </span>
              </Col>
            </Row>
        }
      </div>
    )
  }
  
  renderInboundCobrowse = () => {
    if (this.props.availableModules.includes("INBOUND_CO_BROWSE")) {
      return (
        <>
          <DropdownItem divider />
          <InboundCobrowseSettingsSection
            inboundCobrowseRotation={this.state.inboundCobrowseRotation}
            isInboudCobrowseToggler={this.state.isInboudCobrowseToggler}
            handleInboundCobrowseArrowClick={this.handleInboundCobrowseArrowClick}
            inbConsentMessage={this.state.inbConsentMessage}
            inbShowCoBrowseContent={this.state.inbShowCoBrowseContent ? (this.props.inbShowCoBrowseContent.isEnable ? true : false) : false}
            inbIsMaskingEnabled={this.state.inbIsMaskingEnabled}
            toggleShowCoBrowseContent={allow => this.setState({inbShowCoBrowseContent: allow})}
            handleInbConsentMessage={this.handleInbConsentMessage}
            showCSSelectorAdd={this.state.showCSSelectorAdd}
            onToggle={this.handleToggle}
            addCssItem={this.addCssItem}
            editCssItem={this.editCssItem}
            selectors={this.state.inbGetSelectors}
            toggleInboundMaskingSwitch={this.renderSwitchInboundMasking}
            handleDeleteSelector={this.handleModalDeleteSelector}
            universalLinks={this.state.universalLinks}
            universalLinksEnabled={this.state.universalLinksEnabled}
            showUniversalLinkAdd={this.state.showUniversalLinkAdd}
            onToggleUniversalLinks={this.onToggleUniversalLinks}
            addUniversalLink={this.addUniversalLink}
            editUniversalLink={this.editUniversalLink}
            handleDeleteUniversalLink={this.handleModalDeleteUniversalLink}
            toggleUniversalLinksSwitch={this.toggleUniversalLinksSwitch}
          />
          <DeleteItemModal
            show={this.state.showSelectorDelete}
            deleteTarget={this.state.cssItemDelete}
            handleCancelClick={this.handleModalCancelSelector}
            handleDeleteClick={this.deleteSelector}
          />
          <DeleteItemModal
            show={this.state.showUniversalLinkDelete}
            deleteTarget={this.state.universalLinkItemDelete}
            handleCancelClick={this.handleModalCancelUniversalLink}
            handleDeleteClick={this.deleteUniversalLink}
          />
          
        </>
      );
    }
    return null;
  }

  renderUIGuestSettings = () => {
    if (this.props.availableModules.includes("INBOUND_CO_BROWSE")) {
      return (
        <>
        <UiGuestSettingsSection
          // Rotation and toggler props
          uiGuestSettingsRotation={this.state.uiGuestSettingsRotation}
          isUIGuestSettingsToggler={this.state.isUIGuestSettingsToggler}
          handleUIGuestSettingsArrowClick={this.handleUIGuestSettingsArrowClick}
          // Set Text props
          setTexts={this.state.setTexts}
          showSetTextAdd={this.state.showSetTextAdd}
          onToggleSetText={this.toggleSetTextAdd}
          addSetText={this.addSetText}
          editSetText={this.editSetText}
          handleDeleteSetText={this.handleModalDeleteSetText}
          setTextEnabled={this.state.setTextEnabled}
          toggleSetTextSwitch={this.toggleSetTextSwitch}
          handleCancelClick={this.handleModalCancelSetText}
        />
        <DeleteItemModal
          show={this.state.showSetTextDelete}
          deleteTarget={this.state.setTextItemDelete}
          handleCancelClick={this.handleModalCancelSetText}
          handleDeleteClick={this.deleteSetText}
          parameter={this.state.setTextIndexToDelete}
        />
        </>
        
      );
    }
    return null;
  };

  handleBandwidthSettings = (event) => {
    this.setState({
      [event?.target.name]: isNaN(parseInt(event?.target.value)) ? 360 : parseInt(event?.target.value)
    });
  }
  handleBandwidthCustomSizeSettings = (event) => {
    this.setState({
      [event?.target.name]: isNaN(parseInt(event?.target.value)) ? BANDWIDTH_CUSTOM_SIZE_DEFAULT : parseInt(event?.target.value)
    });
  }
  handleBandwidthCustomBitrateSettings = (event) => {
    this.setState({
      [event?.target.name]: isNaN(parseInt(event?.target.value)) ? BANDWIDTH_CUSTOM_BITRATE_DEFAULT : parseInt(event?.target.value)
    });
  }
  handleEditStorageClick(bucketName, targetStorage) {
    let bucket = null;
    if (!_.isEmpty(bucketName)) {
      bucket = this.state[targetStorage].storageDetails.list?.filter((item =>
        item.credential.bucketName === bucketName
      ))[0];
      this.setState({
        [targetStorage]: {
          ...this.state[targetStorage],
          isEditStorage: true,
          bucketName: bucket.credential.bucketName,
          id: bucket.credential.id,
          secret: bucket.credential.secret,
          currentBucket: bucket.credential.bucketName
        }
      });
    }
  }

  addStorage = (targetStorage) => {
    if (!this.state[targetStorage].bucketName && !this.state[targetStorage].id && !this.state[targetStorage].secret) {
      if (!this.state[targetStorage].isStorageToggler) {
        this.onDownArrowClicked(targetStorage)
      } 
      this.setState((state, props) => {
        return { 
          [targetStorage]: {
            ...state[targetStorage],
            storageErrorMessage: getMessage("EMPTY_MESSAGE")
          }
        }
      });
    }
    else if (this.state[targetStorage].isVerified) {
      let bucket = this.state[targetStorage].storageDetails;
      bucket.type = bucket.type ? bucket.type : "S3";
      bucket.list = bucket.list 
      && this.state[targetStorage].storageDetails?.location === STORAGE_LOCATION.CUSTOMER 
        ? bucket.list : [];
      bucket.location = this.state[targetStorage].storageDetails?.location;

      let isDuplicateStorageDetails =false;
      bucket.list.map((content, i) =>{
        if(content.credential.bucketName === this.state[targetStorage].bucketName
          && content.credential.id === this.state[targetStorage].id
          && content.credential.secret === this.state[targetStorage].secret) {
          // Duplicate Storage Details
          isDuplicateStorageDetails=true;
        }
      });

      if(!isDuplicateStorageDetails) {
        if (!this.state[targetStorage].isEditStorage) {
          let cred = {
            credential: {
              bucketName: this.state[targetStorage].bucketName,
              id: this.state[targetStorage].id,
              secret: this.state[targetStorage].secret
            },
            validation: { status: true },
            isSelected: this.state[targetStorage].isSelected,
          }
          bucket.list.push(cred)
        }
        else {
          let cred = {
            credential: {
              bucketName: this.state[targetStorage].bucketName,
              id: this.state[targetStorage].id,
              secret: this.state[targetStorage].secret
            },
            validation: { status: true }
          };
          bucket.list = bucket.list.map((content, i) =>
            content.credential.bucketName === this.state[targetStorage].bucketName ? {
              ...content, ...cred
            } : content);
        }
        this.resetStorageDetailsFields(targetStorage);
        this.setState((state, props) => {
          return {
            [targetStorage]: {
              ...state[targetStorage],
              storageDetails: bucket
            }
          }
        })
      }
      else{
        this.setState({
          [targetStorage]: {
            ...this.state[targetStorage],
            storageErrorMessage: getMessage("DUPLICATE_STORAGE_CREDENTIALS")
          }
        });
      }
    }
    else {
      if (!this.state[targetStorage].isStorageToggler) {
        this.onDownArrowClicked(targetStorage)
      }
      this.setState((state, props) => {
        return { 
          [targetStorage]: {
            ...state[targetStorage],
            storageErrorMessage: getMessage("BEFORE_VERIFICATION_ERROR")
          }
        }
      });
    }
  }

  handleVerifyStorageDetailsClick = (targetStorage) => {
    this.resetError(targetStorage);
    if (this.state[targetStorage].bucketName 
      && this.state[targetStorage].id && this.state[targetStorage].secret) {
      this.setState({ spinnerVisibility: true });
      let storage = {
        type: 'S3',
        credentials: {
          id: this.state[targetStorage].id,
          secret: this.state[targetStorage].secret,
          bucketName: this.state[targetStorage].bucketName
        }
      };
      this.props.verifyStorage(storage, (error) => {
        if (error.code) {
          this.setState({
            spinnerVisibility: false,
            [targetStorage]: {
              ...this.state[targetStorage],
              isVerified: false, 
              storageErrorMessage: getMessage(error.code) 
            }
          });
          if (!this.state[targetStorage].isStorageToggler) {
            this.onDownArrowClicked(targetStorage);
          }
        }
        else {
          this.setState({
            [targetStorage]: {
              ...this.state[targetStorage],
              spinnerVisibility: false,
              isVerified: true
            }
          });
        }
      })
    }
    else {
      if (!this.state[targetStorage].isStorageToggler) {
        this.onDownArrowClicked(targetStorage);
      }
      this.setState({
        [targetStorage]: {
          ...this.state[targetStorage],
          storageErrorMessage: getMessage("EMPTY_MESSAGE") 
        }
      });
    }
  }

  cancelStorage = (targetStorage) => {
    this.resetStorageDetailsFields(targetStorage);
    this.resetError(targetStorage);
  }

  renderStorageTableBody(targetStorage) {
    return (
      <tbody>
        {this.state[targetStorage].storageDetails.list?.map((item, index) =>
          <tr className="cursorPointer" key={item.credential.id}>
            <td className="storageRow">
              <Input
                type="radio"
                className='oldRadio'
                checked={item.isSelected}
                onChange={() => this.selectDefaultStorage(index, targetStorage)}
              />
              <span className="checkmark" value={item.isSelected}
                onClick={() => this.selectDefaultStorage(index, targetStorage)}>
              </span>
            </td>
            <td className={item.validation?.error?.message ? "storageRowError" : "storageRow"}
              colSpan="2"
              onClick={() => this.selectDefaultStorage(index, targetStorage)}>
              {item.credential?.bucketName}
            </td>
            <td className={item.validation?.error?.message ? "storageRowError" : "storageRow"}
              colSpan="3"
              onClick={() => this.selectDefaultStorage(index, targetStorage)}>
              {item.credential?.id}
            </td>
            <td className={item.validation?.error?.message ? "storageRowError" : "storageRow"}
              colSpan="3"
              onClick={() => this.selectDefaultStorage(index, targetStorage)}>
              ****************************************
            </td>
            <td className={item.validation?.error?.message ? "storageRowError" : "storageRow"}>
              {!item.validation?.status
                ? <img src={ic_error} alt="Status" className="ml-2 cursorPointer"
                  id="bucketError" data-toggle="tooltip" data-placement="bottom"
                  title={item.validation?.error?.message} />
                : null
              }
            </td>
            <td className={item.validation?.error?.message ? "storageRowError" : "storageRow"}>
              <img src={ic_edit} alt="Edit" className="cursorPointer"
                onClick={() => { this.handleEditStorageClick(item.credential.bucketName, targetStorage) }} />
            </td>
          </tr>)}
      </tbody>
    )
  }

  renderButtons = () => {
    return (
      <div className="permissionButtons">
        <Button
          className="buttons borderBtn bgwhite borderRound mr-2"
          onClick={this.props.handleCancelClick}
          type="button">
          {getMessage("CANCEL")}
        </Button>{" "}
        <Button
          className="buttons customBtn"
          onClick={this.handleSaveClick}
          type="button">
          {getMessage("SAVE")}
        </Button>
      </div>
    );
  };

  renderSwitch = (downloadableSubModule, isAvailable) => {
    return (
      <Switch
        switchOn={isAvailable}
        toggleSwitch={(isDownloadAllowed) => this.updateAvailableDownloads(isDownloadAllowed, downloadableSubModule)}
      />
    )
  }

  renderSwitchScreenShare = (subModule, isAvailable) => {
    return (
      <Switch
        switchOn={isAvailable}
        toggleSwitch={(isEnable) => this.updateScreenShare(isEnable, subModule)}
      />
    )
  }

  renderSwitchAudioVideo = (subModule, isAvailable) => {
    return (
      <Switch
        switchOn={isAvailable}
        toggleSwitch={(isEnable) => this.updateAudioVideo(isEnable, subModule)}
      />
    )
  }

  renderSwitchConfirmScreen = (subModule, isAvailable) => {
    return (
      <Switch
        switchOn={isAvailable}
        toggleSwitch={(isEnable) => this.updateConfirmScreen(isEnable, subModule)}
      />
    )
  }

  renderSwitchFixedBrowse = (subModule, isAvailable) => {
    return (
      <Switch
        switchOn={isAvailable}
        toggleSwitch={(isEnable) => this.updateFixedBrowse(isEnable, subModule)}
      />
    )
  }

  renderSwitchAllowEntrySetting = (allow) => {
    return (
      <Switch
        switchOn={allow}
        toggleSwitch={(isEnable) => this.updateAllowEntry(isEnable)}
      />
    )
  }
    
  renderSwitchSnapShot= (subModule, isAvailable) => {
    return (
      <Switch
        switchOn={isAvailable}
        toggleSwitch={(isEnable) => this.updateSnapShot(isEnable, subModule)}
      />
    )
  }
    
  updateAllowEntry = (isEnable) => {
    this.setState({
      isEntryAllowed: isEnable
    })
  }

  setAllowCustomUrl = () => {
    if(this.state.targetSites.length == 0) {
      this.enableCustomURL();
    } else {
      this.setState((prevState) => ({ allowCustomUrl: !prevState.allowCustomUrl }))
    }
  }

  handleAddTargetSiteClick = () => {
    let targetSites = _.cloneDeep(this.state.targetSites);
    let isCustomURLValid = validateCobrowseCustomURL(this.state.targetSiteValue);
    let isduplicate = false ;
   
    if(isCustomURLValid === true) {
      if(this.state.showUpdateTargetSiteSection) {
        targetSites.map((targetsite, index) => { 
          if(index !== this.state.targetSiteIdToEdit &&
             (targetsite.label===this.state.targetSiteLabel || targetsite.url===this.state.targetSiteValue)){
            isduplicate = true;
          }
        })
        if(!isduplicate) {
          targetSites[this.state.targetSiteIdToEdit].label= this.state.targetSiteLabel.trim();
          targetSites[this.state.targetSiteIdToEdit].url= this.state.targetSiteValue;
          this.setState({ targetSites });
          this.onCancelCobrowseClick();
        } else {
          this.setState({ cobrowseURLError : getMessage("DUPLICATE_PRE_CONFIGURED_URL_DETAILS" )})
        }
      }
  
      if(this.state.showAddTargetSiteSection) {
        targetSites.map((targetsite, index) => { 
          if(targetsite.label===this.state.targetSiteLabel || targetsite.url===this.state.targetSiteValue){
            isduplicate = true;
          }
        })
        if(!isduplicate) {
          let targetSite = {
            label: this.state.targetSiteLabel.trim(),
            url: this.state.targetSiteValue
          };
          targetSites.push(targetSite);
          this.setState({ targetSites : targetSites });
          this.onCancelCobrowseClick();
        } else {
          this.setState({ cobrowseURLError : getMessage("DUPLICATE_PRE_CONFIGURED_URL_DETAILS" )})
        }
      };
     
    } else {
      this.setState({ cobrowseURLError : isCustomURLValid })
    }
  };

  enableCustomURL = () => {
    let customUrlLabels = [{label: getMessage("CUSTOM_URL")}]
    this.setState({
      allowCustomUrl : true,
      customUrlLabels : this.state.customUrlLabels && this.state.customUrlLabels[0] && this.state.customUrlLabels[0].label ? this.state.customUrlLabels : customUrlLabels
    })
  }

  handleDeleteUrlClick = (indexId) => {
    let targetSites = this.state.targetSites.filter((site, index ) => index !== indexId);
    this.setState({ targetSites: targetSites});
    if(targetSites.length == 0) {
      this.enableCustomURL();
    }
  }

  handleModalDeleteSelector = (indexId) => {
    let updatedSelectors = this.state.inbGetSelectors;
    this.setState(
      {
        showSelectorDelete: true,
        cssItemDelete: updatedSelectors[indexId]?.selector,
      },
    );
  };

  handleModalCancelSelector = () => {
    this.setState({showSelectorDelete: false});
  }

  deleteSelector = () => {
    let itemToDelete = this.state.cssItemDelete;

    this.setState(prevState => {
      const updatedSelectors = prevState.inbGetSelectors.filter(item => item.selector !== itemToDelete);
      return { inbGetSelectors: updatedSelectors };
    });

    this.handleModalCancelSelector();
  };

  // Universal Links methods - similar to CSS selectors
  addUniversalLink = (link) => {
    this.setState((prevState) => ({
      universalLinks: [...prevState.universalLinks, link]
    }));
  }

  editUniversalLink = (index, link) => {
    this.setState((prevState) => ({
      universalLinks: prevState.universalLinks.map((item, i) =>
        i === index ? link : item
      )
    }));
  }

  // Universal Links - Simplified deletion methods
  handleModalDeleteUniversalLink = (index) => {
    this.setState({
      showUniversalLinkDelete: true,
      universalLinkItemDelete: this.state.universalLinks[index],
    });
  };

  handleModalCancelUniversalLink = () => {
    this.setState({ showUniversalLinkDelete: false });
  }

  deleteUniversalLink = () => {
    const itemToDelete = this.state.universalLinkItemDelete;
    this.setState(prevState => ({
      universalLinks: prevState.universalLinks.filter(link => link !== itemToDelete),
      showUniversalLinkDelete: false
    }));
  };

  onToggleUniversalLinks = (newState) => {
    this.setState({ showUniversalLinkAdd: newState });
  }

  toggleUniversalLinksSwitch = (event) => {
    this.setState({
      universalLinksEnabled: event
    });
  }

  toggleSetTextAdd = (show) => {
    this.setState({ showSetTextAdd: show });
  }

  toggleSetTextSwitch = (event) => {
    this.setState({
      setTextEnabled: event 
    });
  }

  // Set Text methods (add edit delete)
  addSetText = (setTextObject) => {
    this.setState((prevState) => ({
      setTexts: [...prevState.setTexts, setTextObject]
    }));
  }

  editSetText = (index, setTextObject) => {
    this.setState((prevState) => ({
      setTexts: prevState.setTexts.map((item, i) =>
        i === index ? setTextObject : item
      )
    }));
  }

  deleteSetText = (deleteIndex) => {
    this.setState(prevState => ({
      setTexts: prevState.setTexts.filter((setText, index) => {
        return index !== deleteIndex;
      }),
      showSetTextDelete: false,
      setTextIndexToDelete: null,
    }));
  };

  handleModalDeleteSetText = (index) => {
    const item = this.state.setTexts[index];
    this.setState({
      showSetTextDelete: true,
      setTextItemDelete: typeof item === 'object'
        ? item.text || item.value || ''
        : item,
      setTextIndexToDelete: index,
    });
  };

  handleModalCancelSetText = () => {
    this.setState({ 
      showSetTextDelete: false,
      setTextIndexToDelete: null,
    });
  };

  onCancelCobrowseClick = () => {
    this.setState({
      showAddTargetSiteSection: false,
      showUpdateTargetSiteSection: false,
      targetSiteLabel: "",
      targetSiteValue: "",
      cobrowseURLError:""
    });
  }

  handleCobrowseArrowClick = () => {
    this.setState({
      showAddTargetSiteSection: false,
      showUpdateTargetSiteSection: false
    });
    this.onDownArrowClicked(LOCATOR.CO_BROWSE);
  }

  handleAddTargetSiteIconClick = () => {
    this.setState({ 
      targetSiteLabel: "",
      targetSiteValue: "",
      showUpdateTargetSiteSection: false,
      showAddTargetSiteSection: true })
  }

  handleUpdateTargetSiteClick = (index, element) => {
    this.setState({
      showAddTargetSiteSection: false,
      showUpdateTargetSiteSection: true,
      targetSiteIdToEdit: index,
      targetSiteLabel: element.label,
      targetSiteValue: element.url
    })
  }
 
  // Clicking Switch in Modify Cross
  setCoBrowseMutualEditSwitchClick = (toggleFlag) => {
    if(toggleFlag){
      this.setState({
        mutualEdit:true
      })
    }else{
      this.setState({
        mutualEdit:false
      })
    }
  }

  // Clicking Switch in Modify Cross
  setDisableInitiatingCoBrowseSwitchClick = (toggleFlag) => {
    if(toggleFlag){
      this.setState({
        disableInitiatingCoBrowse:true
      })
    }else{
      this.setState({
        disableInitiatingCoBrowse:false
      })
    }
  }

  handleRecordingMethodChange = event => {
    this.setState({
      recordingMethod : event.target.value,
    });
  };
  
  handleRecordingTargetChanged = (event) => {
    const targetName = event.target.name;
    this.setState((state, props) => {
      let newRecordingTarget = []
      if (state.recordingTarget.includes(targetName)) {
        newRecordingTarget = state.recordingTarget.filter(item => {
          return item !== targetName;
        })
      } else {
        newRecordingTarget = [...state.recordingTarget, targetName]
      }
      return { recordingTarget: newRecordingTarget };
    });
  }

  renderSwitchNotifySetting = (userNotifySetting, isAvailable) => {
    return (
      <Switch
        switchOn={isAvailable}
        toggleSwitch={(isEnable) => this.updateNotifySetting(isEnable, userNotifySetting)}
      />
    )
  }

  updateNotifySetting = (allow, userNotifySetting) => {
    if (userNotifySetting === notifySetting.PASSWORD_CHANGED_COMPLETED) {
      this.setState({
        notifyPasswordChangeCompleted: allow
      })
    } else if (userNotifySetting === notifySetting.QR_CODE) {
      this.setState({
        notifyQRCode: allow
      })
    }
  }

  updateUserInviteMsgCustomize = (allow) => {
    this.setState({
      isUserInventMsgCustomizeEnable: allow
    });
  }

  renderSwitchUserInviteMsgCustomize = (isAvailable) => {
    return (
      <Switch
        switchOn={isAvailable}
        toggleSwitch={(isEnable) => this.updateUserInviteMsgCustomize(isEnable)}
      />
    );
  }

  handleEmailAddressInputChange = (event) => {
    this.setState({ [event.target.name]: event.target.value});
    this.resetError();
  }

  handleInbConsentMessage = (event) => {
    this.setState({ [event.target.name]: event.target.value});
    this.resetError();
  }

  addCssItem = (newValue) => {
    this.setState((prevState) => ({
      inbGetSelectors: [
        ...prevState.inbGetSelectors,
        { selector: newValue }
      ]
    }));
  };

  editCssItem = (index, editedSelector) => {
    this.setState((prevState) => ({
      inbGetSelectors: prevState.inbGetSelectors.map((item, i) =>
        i === index ? { ...item, selector: editedSelector } : item
      )
    }));
  };

  handleCoBrowseContentMsgChange = () => {
    this.setState((prevState) => ({ inbShowCoBrowseContent: !prevState.inbShowCoBrowseContent }))
    console.log(this.state.inbShowCoBrowseContent)
  }

  handleToggle = (newState) => {
    this.setState({ showCSSelectorAdd: newState });  // Update state with new value
  };
  
  handleInboundCobrowseArrowClick = () => {
    this.onDownArrowClicked(LOCATOR.INBOUND_CO_BROWSE);
  }

  handleUIGuestSettingsArrowClick = () => {
    this.onDownArrowClicked(LOCATOR.UI_GUEST_SETTINGS);
  }

  renderSwitchInboundMasking = (toggleFlag) => {
    if(toggleFlag){
      this.setState({
        inbIsMaskingEnabled:true
      })
    }else{
      this.setState({
        inbIsMaskingEnabled:false
      })
    }
  }

  updateInboundMasking = (allow) => {
    this.setState({
      inbIsMaskingEnabled: allow
    })
  }

  handleAddEmailClick = () => {
    let emailAddresses = _.cloneDeep(this.state.emailAddresses);
    let isduplicate = false;
    let isValidEmail = validator.isEmail(this.state.emailValue);

    if(this.state.showAddEmailSection) {
      emailAddresses.map((email, index) => {
        if(email.email === this.state.emailValue){
          isduplicate = true;
        }
      });

      if(!isduplicate) {
        if(isValidEmail) {
          let emailAdd = {
            email : this.state.emailValue,
          };
          emailAddresses.push(emailAdd);
          this.setState({ emailAddresses : emailAddresses});
          this.onCancelEmailClick();
        }else {
          this.setState({ emailError : getMessage("VALID_EMAIL")});
        }
      }else {
        this.setState({ emailError : getMessage("DUPLICATE_EMAIL_ADDRESS")});
      }
    }
  }

  handleDeleteEmailClick = (indexId) => {
    let emailAddresses = this.state.emailAddresses.filter((email, index ) => index !== indexId);
    this.setState({ emailAddresses: emailAddresses});
  }

  handleEmailArrowClick = () => {
    this.setState({
      showAddEmailSectionSection: false,
    });
    this.onDownArrowClicked(LOCATOR.EMAIL_LIST);
  }

  handleAddEmailIconClick = () => {
    this.setState({
      targetEmailValue: "",
      showAddEmailSection: true 
    });
  }

  onCancelEmailClick = () => {
    this.setState({
      showAddEmailSection: false,
      emailValue: "",
      emailError: ""
    });
  }

  handleScreenMaskModeChange = event => {
    this.setState({
      screenMaskMode : event.target.value,
    });
  };

  renderSwitchReductionLogs = (isAvailable) => {
    return ( 
      <Switch
        switchOn={isAvailable}
        toggleSwitch={(isEnable) => this.updateReductionLogs(isEnable)}
      />
    )
  }

  updateReductionLogs = (allow) => {
    this.setState({
      isReductionLogs: allow
    })
  }

  renderSwitchHorizontalDisplayFixedSetting = (isAvailable) => {
    return (
      <Switch
        switchOn={isAvailable}
        toggleSwitch={(isEnable) => this.updateHorizontalDisplayFixed(isEnable)}
      />
    )
  }

  updateHorizontalDisplayFixed = (allow) => {
    this.setState({
      horizontalDisplayFixed: allow
    });
  }

  renderSwitchDisableCanvasEditSetting = (isAvailable) => {
    return (
      <Switch
        switchOn={isAvailable}
        toggleSwitch={(isEnable) => this.updateDisableCanvasEdit(isEnable)}
      />
    )
  }

  updateDisableCanvasEdit = (allow) => {
    this.setState({
      disableCanvasEdit: allow
    });
  }

  renderSwitchDisableIcsFileSetting = (isAvailable) => {
    return (
      <Switch
        switchOn={isAvailable}
        toggleSwitch={(isEnable) => this.updateDisableIcsFile(isEnable)}
      />
    )
  }

  updateDisableIcsFile = (allow) => {
    this.setState({
      disableIcsFile: allow
    });
  }

  renderSwitchDisableCanvasDownload = (isAvailable) => {
    return (
      <Switch
        switchOn={isAvailable}
        toggleSwitch={(isEnable) => this.updateDisableCanvasDownload(isEnable)}
      />
    )
  }

  renderPreviewResize= (isAvailable) => {
    return (
      <Switch
        switchOn={isAvailable}
        toggleSwitch={(isEnable) => {this.updateIsPreviewResize(isEnable)}}
      />
    )
  }

  updateIsPreviewResize = (isEnable) => {
    this.setState({
      isPreviewResize: isEnable
    });
  }

  renderSwitchEnableVideoBlurSetting = (isAvailable) => {
    return (
      <Switch
        switchOn={isAvailable}
        toggleSwitch={(isEnable) => this.updateEnableVideoBlur(isEnable)}
      />
    )
  }
 
  updateEnableVideoBlur = (allow) => {
    this.setState({
      enableVideoBlur: allow
    });
  }

  updateDisableCanvasDownload = (allow) => {
    this.setState({
      disableCanvasDownload: allow
    });
  }

  handleSupportCenterArrowClick = () => {
    this.onDownArrowClicked(LOCATOR.SUPPORT_CENTER);
  }

  /** Adds or update the skill listed in the input field to the table. */
  handleAddOperatorSkillClick = () => {
    // id duplicate check
    let isduplicate = false;
    this.state.operatorSkills.map((skill, index) => {
      if (index !== this.state.operatorSkillIndexToEdit
        && skill.id === this.state.targetSkillId) {
        isduplicate = true;
      }
    });
    if (isduplicate) {
      this.setState({skillErrorMessage: getMessage("DUPLICATE_SKILL_ID_ERROR")});
      return;
    }

    const newSkill = {
      id: this.state.targetSkillId,
      name: this.state.targetSkillName,
      startTime: moment(this.state.targetReceptionStartTime, "HH:mm").format(),
      endTime: moment(this.state.targetReceptionEndTime, "HH:mm").format(),
      isReceptionDisabledOnExceptionDays: 
        this.state.targetIsReceptionDisabledOnExceptionDays,
      exceptionDaysOfWeek: this.state.targetExceptionDaysOfWeek, 
      exceptionStartTime: this.state.targetExceptionStartTime 
        && moment(this.state.targetExceptionStartTime, "HH:mm").format(),
      exceptionEndTime: this.state.targetExceptionEndTime 
        && moment(this.state.targetExceptionEndTime, "HH:mm").format(),
      contractDisplayMethod: this.state.targetContractDisplayMethod,
    };
    if (this.state.showAddSkillSection) {
      this.setState((state) => {
        return{
          operatorSkills: [...state.operatorSkills, newSkill]
        }
      });
    } else if (this.state.showUpdateSkillSection) {
      const newOperatorSkills = _.cloneDeep(this.state.operatorSkills);
      newOperatorSkills[this.state.operatorSkillIndexToEdit] = newSkill;
      this.setState({
        operatorSkills: newOperatorSkills
      });
    }
    this.onCancelOperatorSkillClick();
  }

  /** Clear the skill input field. */
  onCancelOperatorSkillClick = () => {
    this.setState({
      targetSkillId: "",
      targetSkillName: "",
      targetReceptionStartTime: "",
      targetReceptionEndTime: "",
      targetIsReceptionDisabledOnExceptionDays: false,
      targetExceptionStartTime: "",
      targetExceptionEndTime: "",
      targetExceptionDaysOfWeek: [],
      targetContractDisplayMethod: CONTRACT_DISPLAY_METHOD.AUTO,
      skillErrorMessage: "",
      showAddSkillSection: false,
      showUpdateSkillSection: false,
      operatorSkillIndexToEdit: ""
    });
  }
  /** (+) button clicked. */
  handleAddOperatorSkillIconClick = () => {
    this.setState({
      targetSkillId: "",
      targetSkillName: "",
      targetReceptionStartTime: "",
      targetReceptionEndTime: "",
      targetIsReceptionDisabledOnExceptionDays: false,
      targetExceptionStartTime: "",
      targetExceptionEndTime: "",
      targetExceptionDaysOfWeek: [],
      targetContractDisplayMethod: CONTRACT_DISPLAY_METHOD.AUTO,
      showAddSkillSection: true,
      showUpdateSkillSection: false,
      operatorSkillIndexToEdit: ""
    });
  }
  /** pencil button clicked. */
  handleUpdateOperatorSkillClick = (index, element) => {
    this.setState({
      targetSkillId: element.id,
      targetSkillName: element.name,
      targetReceptionStartTime: moment(element.startTime).format("HH:mm"),
      targetReceptionEndTime: moment(element.endTime).format("HH:mm"),
      targetIsReceptionDisabledOnExceptionDays: 
        element.isReceptionDisabledOnExceptionDays,
      targetExceptionStartTime: element.exceptionStartTime 
        && moment(element.exceptionStartTime).format("HH:mm"),
      targetExceptionEndTime: element.exceptionEndTime 
        && moment(element.exceptionEndTime).format("HH:mm"),
      targetExceptionDaysOfWeek: element.exceptionDaysOfWeek || [],
      targetContractDisplayMethod: element.contractDisplayMethod,
      showAddSkillSection: false,
      showUpdateSkillSection: true,
      operatorSkillIndexToEdit: index,
    });
  }
  /** trash button clicked. */
  handleDeleteOperatorSkillClick = (deleteIndex) => {
    const deleteOperatorSkill = this.state.operatorSkills.filter((skill, index) => {
      return index === deleteIndex;
    })
    this.setState({
      showDeleteConfirmationModalOperatorSkill: true,
      deleteIndexOperatorSkill: deleteIndex,
      deleteOperatorSkillName: deleteOperatorSkill[0].name,
    });
  }
  handleModalDeleteClickOperatorSkill = (deleteIndex) => {
    const newOperatorSkills = this.state.operatorSkills.filter((skill, index) => {
      return index !== deleteIndex;
    });
    this.setState({
      operatorSkills: newOperatorSkills,
      showDeleteConfirmationModalOperatorSkill: false,
      deleteIndexOperatorSkill: null,
    });
  }
  handleModalCancelClickOperatorSkill = () => {
    this.setState({
      showDeleteConfirmationModalOperatorSkill: false,
      deleteIndexOperatorSkill: null,
    });
  }
  updateOperatorExclusiveRecordingControl = (isEnable) => {
    this.setState({
      operatorExclusiveRecordingControl: isEnable
    });
  }

  updateRingtoneLoopEnabled = (isEnable) => {
    this.setState({
      ringtoneLoopEnabled: isEnable
    });
  }

  renderDisableCanvasDownload = () => {
    return (
      <Row className="noMargin" >
        <Col xs={9}>
          {getMessage("DISABLE_CANVAS_DOWNLOAD_GUEST")}
        </Col>
        <Col xs={3} className="pl-2 switchBtnsMargin">
          {this.renderSwitchDisableCanvasDownload(
            this.state.disableCanvasDownload)}
        </Col>
      </Row>
    )
  }

  render() {
    let uriIdentifier =  "";
    if(this.props.uriIdentifier){
      uriIdentifier = "/" + this.props.uriIdentifier;
    }
    let loginURL = "https://" + this.state.cognitoDomain + '/oauth2/authorize?' + '&response_type=code'+'&client_id=' + this.state.clientId + '&redirect_uri=' + window.location.origin + uriIdentifier + CONFIG.path.ssoLogin + "&state=STATE" + '&identity_provider=' + this.state.identityProvider;
    let emailError = getMessage('EMAIL_NOT_SENT_ERROR');
    let { seats, maxConcurrentSessions, businessModel,concurrentSessionEmailInterval } = { ...this.props.concurrentSessionData }
    concurrentSessionEmailInterval = concurrentSessionEmailInterval ? concurrentSessionEmailInterval : 0;
    return (
      <div
        className="settingsModal px-md-5"
        backdrop="static">
        <div className="settingsBody">

          <div className="section">
            <Row className="noMargin">
              <Col md={11} className="mainTitle">
                {getMessage("BUSINESS_MODEL")}
              </Col>
            </Row>
            <Row className="noMargin mt-1">
              <Col xs={5} className="pr-0"> {getMessage("SELECTED_BUSINESS_MODEL")}:
              </Col>
              <Col xs={7} className="pl-0">
                {/* code change for DEFC0359818 */}
                {
                  businessModel === BUSINESS_MODELS.NUMBER_OF_SEATS
                    ? getMessage("NO_OF_SEATS")
                    : businessModel === BUSINESS_MODELS.NUMBER_OF_DEVICES_ACCESSED
                      ? getMessage("DEVICES_ACCESSED")
                      : getMessage("MAX_CONCURRENT_CONNECTIONS")
                }
              </Col>
            </Row>
            {businessModel == BUSINESS_MODELS.NUMBER_OF_SEATS && <Row className="noMargin mt-4 mb-4">
              <Col xs={5} className="pr-0"> {getMessage("NO_OF_SEATS")}:
              </Col>
              <Col xs={7} className="pl-0">{seats}</Col>
            </Row>}
            {businessModel == BUSINESS_MODELS.MAX_CONCURRENT_CONNECTIONS && <div>
              <Row className="noMargin mt-4 mb-4">
                <Col xs={5} className="pr-0"> {getMessage("MAX_CONCURRENT_CONNECTIONS_LABEL")}:
                </Col>
                <Col xs={7} className="pl-0">{maxConcurrentSessions}</Col>
              </Row>
              <Row className="noMargin mt-2">
                <Col xs={5} className="pr-0"> {getMessage("THRESHOLD_VALUE")}:
                </Col>
                <Col xs={6} className="pl-0 thresholdCol">
                  <NumericInput
                    className="inputFormControl"
                    name="concurrentSessionThreshold"
                    value={this.state.concurrentSessionThreshold}
                    min={0}
                    placeholder={getMessage("THRESHOLD_VALUE")}
                    strict={this.state.concurrentSessionThreshold <= maxConcurrentSessions}
                    onChange={(value) => this.handleThresholdInputChange("concurrentSessionThreshold", value, maxConcurrentSessions)}
                    required
                  />
                </Col>
                {this.state.concurrentSessionThreshold <= 0 ? null :
                  <Col xs={1} className="infoIconCol align-self-center">
                    <img src={ic_info_grey} className="cursorPointer floatRight mr-5"
                      data-toggle="tooltip" data-placement="top" title={getMessage('THRESHOLD_TOOLTIP_MESSAGE', { minutes: (Math.floor((concurrentSessionEmailInterval) / 60000)) })}
                    />
                  </Col>}
              </Row>
              <Row className="noMargin mt-2">
                <Col xs={5} className="pr-0"> {getMessage("THRESHOLD_EMAIL")}:
                </Col>
                <Col xs={7} className="pl-0">
                  <Input
                    disabled = {this.state.concurrentSessionThreshold <= 0 ? true: false}
                    type="text"
                    name="emailIds"
                    className="inputFormControl"
                    required
                    placeholder={getMessage("EMAILS_INPUT_PLACEHOLDER")}
                    onChange={this.handleEmailInputChange()}
                    value={this.state.emailIds}
                  />
                  <Row className="d-flex errors my-0 py-2 float-left">
                    {this.state.concurrentSessionThreshold <= 0 ? emailError : this.state.emailErrorMessage ? this.state.emailErrorMessage
                      : ""}
                  </Row>
                </Col>                
              </Row>
            </div>}
          </div>
          <div className="display-none">
            <DropdownItem divider />
          </div>

          { (this.props.availableModules.includes("RECORDING")) &&
          <>
            <div className="section">
              <Row className="noMargin">
                <Col md={11} className="mainTitle col">{getMessage("AUDIO_VIDEO_RECORDING")}
                </Col>
              </Row>
              <Row className="noMargin pb-3">
                <Col xs={5} className="pr-0 pb-2 pb-lg-auto col-lg-5 col-md-3 col-3">{getMessage("RECORDING_METHOD")}:</Col>
                <Col className="px-0 pb-2 pb-lg-auto col-xl-3 col-lg-4 col-md-9 col-7">
                  <Input type="select" name="recordingMethod" 
                    className="inputFormControl form-control border" 
                    onChange={this.handleRecordingMethodChange}
                    value={this.state.recordingMethod}
                  >
                    <option value={RECORDING_METHOD.OFF}>{getMessage(RECORDING_METHOD.OFF)}</option>
                    <option value={RECORDING_METHOD.AUTO}>{getMessage(RECORDING_METHOD.AUTO)}</option>
                    <option value={RECORDING_METHOD.MANUAL}>{getMessage(RECORDING_METHOD.MANUAL)}</option>
                  </Input>
                </Col>
              </Row>
              <Row className="noMargin">
                <Col xs={5}>{getMessage("RECORDING_TARGET")}:</Col>
                <Col xs={7}>
                  <Row>
                    {Object.keys(RECORDING_TARGET).map((key) => {
                      return (
                        <Col md={4} xs={12} key={key}>
                          <Label className="label noPadding">
                            <Input
                              type="checkbox"
                              name={RECORDING_TARGET[key]}
                              onChange={this.handleRecordingTargetChanged}
                              disabled={RECORDING_TARGET[key] == RECORDING_TARGET.FULL_SCREEN_SHARING }
                              checked={this.state.recordingTarget.includes(RECORDING_TARGET[key])}
                            />
                            {getMessage(RECORDING_TARGET[key])}
                          </Label>
                        </Col>
                      )
                    })}
                  </Row>
                </Col>
              </Row>
            </div>
            {this.renderStorageDetailSetting(STORAGE.RECORDING_STORAGE)}
            <Row className="noMargin mt-2">
              <Col xs={5} className="pr-0">{getMessage("MODAL_RECORDING_MESSAGE")}:
              </Col>
              <Col xs={7} className="pl-0">
                <Input
                  type="text"
                  name="modalRecordingMessage"
                  onChange={this.handleRecordingInputChange}
                  className="inputFormControl"
                  value={this.state.modalRecordingMessage}
                  maxLength="20"
                />
              </Col>
            </Row>
            <Row className="noMargin mt-2">
              <Col xs={5} className="pr-0">{getMessage("AUDIO_RECORDING_MESSAGE")}:
              </Col>
              <Col xs={7} className="pl-0">
                <Input
                  type="text"
                  name="audioRecordingMessage"
                  onChange={this.handleRecordingInputChange}
                  className="inputFormControl"
                  value={this.state.audioRecordingMessage}
                  maxLength="20"
                />
              </Col>
            </Row>
            <Row className="noMargin mt-2">
              <Col xs={5} className="pr-0">{getMessage("VIDEO_RECORDING_MESSAGE")}:
              </Col>
              <Col xs={7} className="pl-0">
                <Input
                  type="text"
                  name="videoRecordingMessage"
                  onChange={this.handleRecordingInputChange}
                  className="inputFormControl"
                  value={this.state.videoRecordingMessage}
                  maxLength="20"
                />
              </Col>
            </Row>

            <Row className="noMargin mt-2">
              <Col xs={5} className="pr-0">{getMessage("RETENTION_PERIOD")}:
              </Col>
              <Col xs={4} className="pl-0">
                <Input
                  type="number"
                  name="retentionPeriod"
                  onChange={this.handleInputChange}
                  className="inputFormControl"
                  value={this.state.retentionPeriod}
                  maxLength="4"
                />
              </Col>
              <Col>
                {getMessage("ZERO_IS_UNLIMITED")}
              </Col>
            </Row>

            <Row className="noMargin mt-2">
              <Col xs={5} className="pr-0">{getMessage("NEW_PASSWORD")}:
              </Col>
              <Col xs={7} className="pl-0">
                <Input
                  type="password"
                  name="newRecordingPassword"
                  onChange={this.handleInputChange}
                  className="inputFormControl"
                  value={this.state.newRecordingPassword}
                  maxLength="15"
                  placeholder={getMessage("ENTER_TO_CHANGE")}
                />
              </Col>
            </Row>

            <Row className="noMargin mt-2">
              <Col xs={5} className="pr-0">{getMessage("RESET_CONFIRM_PASSWORD")}:
              </Col>
              <Col xs={7} className="pl-0">
                <Input
                  type="password"
                  name="confirmRecordingPassword"
                  onChange={this.handleInputChange}
                  className="inputFormControl"
                  value={this.state.confirmRecordingPassword}
                  maxLength="15"
                />
              </Col>
            </Row>
            {this.state.recordingPasswordErrorMessage ?
              <Row>
                <Col md={12} className="errors autoHeight">
                  {this.state.recordingPasswordErrorMessage}
                </Col>
              </Row>
              : null
            }
            <DropdownItem divider />
          </>}

          <div>
            <div className="section-hide">
              <Row className="noMargin">
                <Col md={11} className="mainTitle">
                  {getMessage("SHORT_MAIL_SERVICE")}
                </Col>
              </Row>

              {this.state.isSMSEnabled &&
                <>
                  <Row className="noMargin mt-1">
                    <Col xs={5} className="pr-0"> {getMessage("MAX_NUMBER_OF_SENDS")}:
                    </Col>
                    <Col className="px-0 pb-2 pb-lg-auto col-xl-3 col-lg-4 col-md-9 col-7">
                      <NumericInput
                        className="ml-1 inputFormControl"
                        name="maxSmsSend"
                        value={this.state.maxSmsSend}
                        min={0}
                        max={9999999999}
                        maxLength={10}
                        strict={true}
                        precision={0}
                        onChange={(value) => this.handleThresholdInputChange("maxSmsSend", value, 9999999999)}
                        required   
                      />
                    </Col>
                    <Col>
                      {getMessage("ZERO_IS_UNLIMITED")}
                    </Col>
                  </Row>
                  <Row className="noMargin mt-1">
                    <Col xs={5} className="pr-0"> {getMessage("SMS_SENDER_ID")}:
                    </Col>
                    <Col className="px-0 pb-2 pb-lg-auto col-xl-3 col-lg-4 col-md-9 col-7">
                      <Input
                        type="text"
                        name="senderId"
                        onChange={this.handleInputChange}
                        className="inputFormControl"
                        value={this.state.senderId}
                        maxLength="11"
                        required
                      />
                      <Row className="d-flex errors my-0 py-2 float-left">
                        {this.state.senderIdErrorMessage ? this.state.senderIdErrorMessage
                          : ""}
                      </Row>
                    </Col>
                  </Row>
                </>
              }

              <Row className="noMargin mt-1">
                <Col xs={5} className="pr-0"> {getMessage("INVITE_MSG_CUSTOMIZE")}:
                </Col>
                <Col className="switchBtnsMargin">
                  {this.renderSwitchUserInviteMsgCustomize(this.state.isUserInventMsgCustomizeEnable)}
                </Col>
              </Row>
              <Row className="noMargin">
                <Col>
                  <EmailSettingsSection
                    emailListRotation={this.state.emailListRotation}
                    handleEmailArrowClick={this.handleEmailArrowClick}
                    isEmailListToggler={this.state.isEmailListToggler}
                    showAddEmailSection={this.state.showAddEmailSection}
                    emailAddresses={this.state.emailAddresses}
                    handleAddEmailIconClick={this.handleAddEmailIconClick}
                    handleDeleteEmailClick={this.handleDeleteEmailClick}
                    onCancelEmailClick={this.onCancelEmailClick}
                    handleEmailAddressInputChange={this.handleEmailAddressInputChange}
                    emailValue={this.state.emailValue}
                    emailError={this.state.emailError}
                    handleAddEmailClick={this.handleAddEmailClick}
                  />
                </Col>
              </Row>
              <Row className="noMargin mt-1">
                <Col xs={5} className="pr-0"> {getMessage("ICS_FILE_SETTING")}:
                </Col>
                <Col className="switchBtnsMargin">
                  {this.renderSwitchDisableIcsFileSetting(this.state.disableIcsFile)}
                </Col>
              </Row>
            </div>
            <div className="section">
              <DropdownItem divider />
            </div>
          </div>

          <div className="section">
            <Row className="noMargin">
              <Col md={11} className="mainTitle">
                {getMessage("SINGLE_SIGN_ON")}
              </Col>
              {this.state.SSODetails.isSSOEnabled ?
                <Col>
                  <img
                    style={{ transform: `rotate(${this.state.ssoRotation}deg)` }}
                    className="dropDown cursorPointer floatRight"
                    src={ic_arrow_down}
                    onClick={() => this.onDownArrowClicked(LOCATOR.SSO)} />
                </Col> : null}
            </Row>
            {this.state.SSODetails.isSSOEnabled ?
              <Collapse isOpen={this.state.isSSOToggler}>
                <Row className="noMargin mt-2">
                  <Col xs={5} className="pr-0"> {getMessage("CLIENT_ID")}:
                  </Col>
                  <Col xs={7} className="pl-0">
                    <Input
                      type="text"
                      name="clientId"
                      className="inputFormControl"
                      required
                      placeholder={getMessage("CLIENT_ID_PLACEHOLDER")}
                      onChange={this.handleInputChange}
                      value={this.state.clientId}
                    />
                  </Col>
                </Row>
                <Row className="noMargin mt-2">
                  <Col xs={5} className="pr-0"> {getMessage("COGNITO_DOMAIN")}:
                  </Col>
                  <Col xs={7} className="pl-0">
                    <Input
                      type="text"
                      name="cognitoDomain"
                      className="inputFormControl"
                      required
                      placeholder={getMessage("COGNITO_DOMAIN_PLACEHOLDER")}
                      onChange={this.handleInputChange}
                      value={this.state.cognitoDomain}
                    />
                  </Col>
                </Row>
                <Row className="noMargin mt-2">
                  <Col xs={5} className="pr-0"> {getMessage("IDENTITY_PROVIDER")}:
                  </Col>
                  <Col xs={7} className="pl-0">
                    <Input
                      type="text"
                      name="identityProvider"
                      className="inputFormControl"
                      required
                      placeholder={getMessage("IDENTITY_PROVIDER_PLACEHOLDER")}
                      onChange={this.handleInputChange}
                      value={this.state.identityProvider}
                    />
                  </Col>
                </Row> 
                <Row className="noMargin mt-2">
                  <Col xs={5} className="pr-0"> {getMessage("CLIENT_SECRET")}:
                  </Col>
                  <Col xs={7} className="pl-0">
                    <Input
                      type="password"
                      name="clientSecret"
                      className="inputFormControl"
                      required
                      placeholder={getMessage("CLIENT_SECRET")}
                      onChange={this.handleInputChange}
                      value={this.state.clientSecret}
                    />
                  </Col>
                </Row>
                <Row className="noMargin mt-2">
                  <Col xs={5} className="pr-0"> {getMessage("USER_POOL_ID")}:
                  </Col>
                  <Col xs={7} className="pl-0">
                    <Input
                      type="text"
                      name="userPoolId"
                      className="inputFormControl"
                      required
                      placeholder={getMessage("USER_POOL_ID")}
                      onChange={this.handleInputChange}
                      value={this.state.userPoolId}
                    />
                  </Col>
                </Row>
                <Row className="noMargin mt-2">
                  <Col xs={5} className="pr-0">
                    {getMessage("LOGIN_URL")}:
                  </Col>
                </Row>
                <Row className="noMargin mt-2">
                  <Col md={12} className="text-muted autoHeight loginURL">
                    {loginURL}
                  </Col>
                </Row>
                {this.state.ssoErrorMessage ?
                  <Row>
                    <Col md={12} className="errors autoHeight">
                      {getMessage(this.state.ssoErrorMessage)}
                    </Col>
                  </Row>
                  : null
                }
              </Collapse>
              :
              <Row className="pb-2">
                <Col xs={12}><span className="ml-3">
                  {getMessage("SSO_NOT_ENABLE_MESSAGE")}
                </span>
                </Col>
              </Row>
            }
            <DropdownItem divider />
          </div>
          
          <div className="section" id="passwordPolicy">
            <Row className="noMargin">
              <Col className="mainTitle">
                {getMessage("PASSWORD_POLICY")}
              </Col>
            </Row>
            <Row className="noMargin mt-1">
              <Col xs={5} className="pr-0"> {getMessage("PASSWORD_LENGTH")}:</Col>
              <Col className="px-0 pb-2 pb-lg-auto col-xl-3 col-lg-4 col-md-9 col-7">
                <NumericInput
                  className="ml-1 inputFormControl"
                  name="maxPasswordLength"
                  value={this.state.passwordLength}
                  min={minPassLength}
                  onChange={(value) => this.handleMaxPassLenChange("passwordLength", value, maxPassLength)}
                  required   
                />
              </Col>
            </Row>
            <Row className="noMargin mt-1">
              <Col xs={5} className="pr-0">{getMessage("PASSWORD_STRENGTH")}:</Col>
              <Col xs={7}>
                {Object.keys(passwordPolicy).map((key) => {
                  return (
                    <Row className="noMargin" key={key}>
                      <Label className="label noPadding">
                        <Input
                          type="checkbox"
                          name={passwordPolicy[key]}
                          checked={this.pwPolicy(passwordPolicy[key])}
                          onChange={this.changePwPolicy}
                        />
                        {getMessage(key)}
                      </Label>
                    </Row>
                  )
                })}
                <Row className="d-flex errors my-0 py-2 float-left">
                  {this.state.policyErrorMessage ? this.state.policyErrorMessage
                    : ""}
                </Row>
              </Col>
            </Row>
            <Row className="noMargin mt-1">
              <Col xs={5} className="pr-0">{getMessage("CHECK_PAST_PASSWORD")}:</Col>
              <Col xs={7} className="px-0 pb-2 pb-lg-auto col-xl-3 col-lg-4 col-md-9 col-7">
                <NumericInput
                  className="ml-1 inputFormControl"
                  name="maxPasswordLimit"
                  value={this.state.pastPasswordLimit}
                  min={minPassHist}
                  onChange={(value) => this.handleMaxPassLenChange("pastPasswordLimit", value, maxPassHist)}
                  required
                />
              </Col>
            </Row>
          </div>
          <DropdownItem divider />
          <div className="section">
            <Row className="noMargin">
              <Col className="mainTitle">
                {getMessage("MEETING_SETTINGS")}
              </Col>
            </Row>
            {this.props.isPasscodeEnabled &&
             <Row className="pb-2 noMargin">
               <Col xs={3}>{getMessage("USERS_ENTRY_CONFIG")}</Col>
               <Col xs={9}>
                 <Row className="pb-2 noMargin">
                   <Col xs={8}><span className="subtitle">
                     {getMessage("ALLOW_ENTRY_SETTING")}</span>
                   </Col>
                   <Col xs={4} className="switchBtnsMargin">
                     {this.renderSwitchAllowEntrySetting(this.state.isEntryAllowed)}
                   </Col>
                 </Row>
               </Col>
             </Row>
            }
            <Row className="noMargin-hide">
              <Col xs={3}>{getMessage("APPROVAL_REDUCTION_SETTINGS")}</Col>
              <Col xs={9}>
                <Row className="pb-2 noMargin">
                  <Col xs={8}><span className="subtitle">
                    {getMessage("APPROVAL_REDUCTION_SCREEN")}</span>
                  </Col>
                  <Col xs={4} className="switchBtnsMargin">
                    {this.renderSwitchReductionLogs(this.state.isReductionLogs)}
                  </Col>
                </Row>
              </Col>
            </Row>
            { ( this.props.isVideoSelected || this.props.isScreenShareSelected ) &&
              <Row className="noMargin-hide">
                <Col xs={3}>{getMessage("MEETING_SCREEN_INTERFACE")}</Col>
                <Col xs={9}>
                  <Row className="pb-2 noMargin">
                    <Col xs={8}><span className="subtitle">
                      {getMessage("FIX_HORIZONTAL_DISPLAY_ON_SP")}</span>
                    </Col>
                    <Col xs={4} className="switchBtnsMargin">
                      {this.renderSwitchHorizontalDisplayFixedSetting(
                        this.state.horizontalDisplayFixed)}
                    </Col>
                  </Row>
                </Col>
              </Row>
            }

            <Row className="noMargin-hide">
              <Col xs={3}>{getMessage("CANVAS_SETTING")}</Col>
              <Col xs={9}>
                <Row className="pb-2 noMargin">
                  <Col xs={8}><span className="subtitle">
                    {getMessage("DISABLE_CANVAS")}</span>
                  </Col>
                  <Col xs={4} className="switchBtnsMargin">
                    {this.renderSwitchDisableCanvasEditSetting(
                      this.state.disableCanvasEdit)}
                  </Col>
                </Row>
              </Col>
            </Row>

            {this.props.isDownloadModuleSelected && 
            <>
              <Row className="noMargin">
                <Col xs={3}>{getMessage("ALLOW_DOWNLOAD_FOR")}</Col>
                <Col xs={9}>
                  {listOfAvailableSubModule.map((downloadableSubModule) => {
                    if (downloadableSubModule in downloadableModules) {
                      return (
                        <Row className="pb-2 noMargin" key={downloadableSubModule}>
                          <Col xs={8}><span className="subtitle">
                            {getMessage(downloadableSubModule)}</span>
                          </Col>
                          <Col xs={4} className="switchBtnsMargin">
                            {this.renderSwitch(downloadableSubModule,
                              this.state.allowedDownloads && this.state.allowedDownloads.hasOwnProperty(downloadableSubModule))}
                          </Col>
                        </Row>
                      )
                    }
                  })}
                </Col>
              </Row>                
              {this.renderDisableCanvasDownload()}
            </>
            } 
          </div>
          <div className="hide">
            <Col xs={3}>{getMessage("LOGGING")}</Col>
            <Col xs={9}>
              <Row className="pb-2 noMargin">
                <Col xs={3}><span className="subtitle">
                  {getMessage("LOG_TYPE_BASIC")}</span>
                </Col>
                <Col xs={9}>
                  <Row>
                    {Object.keys(subLoggingLevels.basic).map((key) => {
                      return (
                        <Col xs={12} key={key}>
                          <Label className="label noPadding">
                            <Input
                              type="checkbox"
                              name={subLoggingLevels.basic[key]}
                              onChange={this.handleSubLoggingLevelsChanged}
                              disabled={defaultSubLoggingLevels && defaultSubLoggingLevels.indexOf(subLoggingLevels.basic[key]) >= 0}
                              checked={defaultSubLoggingLevels && defaultSubLoggingLevels.indexOf(subLoggingLevels.basic[key]) > -1
                                  || this.state.subLoggingLevels.indexOf(subLoggingLevels.basic[key]) > -1}
                            />
                            {getMessage(key)}
                          </Label>
                        </Col>
                      )
                    }
                    )}
                  </Row>
                </Col>
              </Row>
              
            </Col>
          </div>
          <Row className="noMargin-hide">
            <Col xs={3}></Col>
            <Col xs={9}>
              <Row className="pb-2 noMargin">
                <Col xs={3}><span className="subtitle">
                  {getMessage("LOG_TYPE_ADVANCED")}</span>
                </Col>
                <Col xs={9}>
                  <Row>
                    {Object.keys(subLoggingLevels.advanced).map((key) => {
                      return (
                        <Col md={6} xs={12} key={key}>
                          <Label className="label noPadding">
                            <Input
                              type="checkbox"
                              name={subLoggingLevels.advanced[key]}
                              onChange={this.handleSubLoggingLevelsChanged}
                              disabled={this.props.loggingLevel !== loggingLevel.ADVANCED}
                              checked={this.state.subLoggingLevels.indexOf(subLoggingLevels.advanced[key]) > -1}
                            />
                            {getMessage(key)}
                          </Label>
                        </Col>
                      )
                    }
                    )}
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>

          { this.props.isVideoSelected &&
            <div className="section-hide">
              <Row className="noMargin">
                <Col xs={3}>{getMessage("AUDIO_VIDEO")}</Col>
                <Col xs={9}>
                  {listOfAvailableSubModule.map((audiovideoSubModules) => {
                    if (audiovideoSubModules == "SHOW_PREVIEW") {
                      return (
                        <Row className="pb-2 noMargin" key={audiovideoSubModules}>
                          <Col xs={8}><span className="subtitle">
                            {getMessage(audiovideoSubModules)}</span>
                          </Col>
                          <Col xs={4} className="switchBtnsMargin pl-2">
                            {this.renderSwitchAudioVideo(audiovideoSubModules,
                              true)}
                          </Col>
                        </Row>
                      )
                    }
                  }
                  )}
                  <Row className="pb-2 noMargin">
                    <Col xs={8}><span className="subtitle">
                      {getMessage("PREVIEW_RESIZE")}</span>
                    </Col>
                    <Col xs={4} className="switchBtnsMargin pl-2">
                      {this.renderPreviewResize(this.state.isPreviewResize)}
                    </Col>
                  </Row>
                  <Row className="pb-2 noMargin">
                    <Col xs={8}><span className="subtitle">
                      {getMessage("VIDEO_BLUR_SETTINGS")}</span>
                    </Col>
                    <Col xs={4} className="switchBtnsMargin pl-2">
                      {this.renderSwitchEnableVideoBlurSetting(
                        this.state.enableVideoBlur)}
                    </Col>
                  </Row>
                </Col>
              </Row>
              {this.props.isVideoOrSnapshotSelected &&
               <Row className="noMargin pb-3">
                 <Col xs={3}></Col>
                 <Col xs={9}>
                   <Row className="noMargin d-flex">
                     <Col xs={2} className="align-items-start">
                       <span className="subtitle">
                         {getMessage("BANDWIDTH")}
                       </span>
                     </Col>
                     <Col xs={10}>
                       <Row className="align-items-center">
                         <Col xs={6}>
                           <Input type="select" name="videoStreamBandwidth" 
                             className="inputFormControl form-control border" 
                             onChange={this.handleBandwidthSettings}
                             value={this.state.videoStreamBandwidth}>
                             {BANDWIDTH_MANAGEMENT_LIST.map(bandwidth => (
                               <option key={bandwidth.value} value={bandwidth.value}>
                                 {getMessage(bandwidth.name,{bandwidth: bandwidth.value, bitrate: bandwidth.bitrate})}
                               </option>
                             ))}
                             <option key={BANDWIDTH_CUSTOM} value={BANDWIDTH_CUSTOM}>
                               {getMessage('CUSTOM_BANDWIDTH')}
                             </option>
                           </Input>
                         </Col>
                         <Col xs={1}><label>@</label></Col>
                         <Col xs={3}>
                           <Input type="select" name="videoStreamFPS" 
                             className="inputFormControl form-control border p-1"
                             onChange={this.handleBandwidthSettings}
                             value={this.state.videoStreamFPS}>
                             {FRAMES_PER_SECOND_LIST.map(frames=>(
                               <option key={frames} value={frames}>
                                 {getMessage(frames)}
                               </option>
                             ))}
                           </Input>
                         </Col>
                         <Col><label className="pt-2">{getMessage("FPS")}</label></Col>
                       </Row>
                       {this.state.videoStreamBandwidth == BANDWIDTH_CUSTOM &&
                         <Row className="align-items-center pt-1">
                           <Col xs={3} className="pr-0">
                             <Input type="select" name="videoStreamCustomSize"
                               className="inputFormControl form-control border"
                               onChange={this.handleBandwidthCustomSizeSettings}
                               value={this.state.videoStreamCustomSize}>
                               {BANDWIDTH_MANAGEMENT_LIST.map(bandwidth => (
                                 <option key={bandwidth.value} value={bandwidth.value}>
                                   {bandwidth.value}p
                                 </option>
                               ))}
                             </Input>
                           </Col>
                           <Col xs={1} className="text-center"><label className="pt-2">-</label></Col>
                           <Col xs={3} className="pl-0 pr-0">
                             <Input type="select" name="videoStreamCustomBitrate"
                               className="inputFormControl form-control border"
                               onChange={this.handleBandwidthCustomBitrateSettings}
                               value={this.state.videoStreamCustomBitrate}>
                               {BANDWIDTH_CUSTOM_BANDWIDTH_LIST.map(bandwidth => (
                                 <option key={bandwidth.value} value={bandwidth.value}>
                                   {bandwidth.bitrate ? bandwidth.bitrate : getMessage(bandwidth.name)}
                                 </option>
                               ))}
                             </Input>
                           </Col>
                         </Row>
                       }
                     </Col>
                   </Row>
              
                 </Col>
               </Row>
              }
            </div>
          }

          { this.props.isScreenShareSelected &&
            <div className="section">
              <Row className="noMargin">
                <Col xs={3}>{getMessage("SCREENSHARE")}</Col>
                <Col xs={9}>
                  {listOfAvailableSubModule.map((screenshareSubModules) => {
                    if (screenshareSubModules == "VIEW_SCREEN") {
                      return (
                        <Row className="pb-2 noMargin" key={screenshareSubModules}>
                          <Col xs={8}><span className="subtitle">
                            {getMessage(screenshareSubModules)}</span>
                          </Col>
                          <Col xs={4} className="switchBtnsMargin pl-2">
                            {this.renderSwitchScreenShare(screenshareSubModules,
                              this.props.isScreenShareSelected && this.state.subModulesScreenshare.hasOwnProperty(screenshareSubModules))}
                          </Col>
                        </Row>
                      )
                    }
                  }
                  )}
                </Col>
              </Row>
              <Row className="noMargin">
                <Col xs={3}></Col>
                <Col xs={9}>
                  <Row className="noMargin d-flex align-items-center">
                    <Col xs={2}><span className="subtitle">{getMessage("SCREEN_MASK")}</span></Col>
                    <Col xs={9}>
                      <Input type="select" name="recordingMethod" 
                        className="inputFormControl form-control border" 
                        onChange={this.handleScreenMaskModeChange}
                        value={this.state.screenMaskMode}
                      >
                        <option className="hide" value={SCREEN_MASK_MODE.PRESENTER}>{getMessage("SCREEN_MASK_MODE_PRESENTER")}</option>
                        <option value={SCREEN_MASK_MODE.AGENT}>{getMessage("SCREEN_MASK_MODE_AGENT")}</option>
                        <option value={SCREEN_MASK_MODE.NOT_USE}>{getMessage("SCREEN_MASK_MODE_NOT_USE")}</option>
                      </Input>
                    </Col>
                  </Row>
                  
                </Col>
                
              </Row>  
              <Row className="noMargin pb-3 pt-3">
                <Col xs={3}></Col>
                <Col xs={9}>
                  <Row className="noMargin pb-3 d-flex">
                    <Col xs={2} className="align-items-start">
                      <span className="subtitle">
                        {getMessage("BANDWIDTH")}
                      </span>
                    </Col>
                    <Col xs={10}>
                      <Row className="align-items-center"> 
                        <Col xs={6}>
                          <Input type="select" name="screenShareBandwidth" 
                            className="inputFormControl form-control border" 
                            onChange={this.handleBandwidthSettings} 
                            value={this.state.screenShareBandwidth}>
                            {BANDWIDTH_MANAGEMENT_LIST.map(bandwidth=>(
                              <option key={bandwidth.value} value={bandwidth.value}>
                                {getMessage(bandwidth.name, {bandwidth: bandwidth.value, bitrate: bandwidth.bitrate})}
                              </option>
                            ))}
                            <option key={BANDWIDTH_CUSTOM} value={BANDWIDTH_CUSTOM}>
                              {getMessage('CUSTOM_BANDWIDTH')}
                            </option>
                          </Input>
                        </Col>
                        <Col xs={1}><label>@</label></Col>
                        <Col xs={3}>
                          <Input type="select" name="screenShareFPS"
                            className="inputFormControl form-control border p-1" 
                            onChange={this.handleBandwidthSettings} 
                            value={this.state.screenShareFPS}>
                            {FRAMES_PER_SECOND_LIST.map(frames=>(
                              <option key={frames} value={frames}>
                                {getMessage(frames)}
                              </option>
                            ))}
                          </Input>
                        </Col>
                        <Col>
                          <label className="pt-2">{getMessage("FPS")}</label>
                        </Col>
                      </Row>
                      {this.state.screenShareBandwidth == BANDWIDTH_CUSTOM &&
                        <Row className="align-items-center pt-1">
                          <Col xs={3} className="pr-0">
                            <Input type="select" name="screenShareCustomSize"
                              className="inputFormControl form-control border"
                              onChange={this.handleBandwidthCustomSizeSettings}
                              value={this.state.screenShareCustomSize}>
                              {BANDWIDTH_MANAGEMENT_LIST.map(bandwidth => (
                                <option key={bandwidth.value} value={bandwidth.value}>
                                  {bandwidth.value}p
                                </option>
                              ))}
                            </Input>
                          </Col>
                          <Col xs={1} className="text-center"><label className="pt-2">-</label></Col>
                          <Col xs={3} className="pl-0 pr-0">
                            <Input type="select" name="screenShareCustomBitrate"
                              className="inputFormControl form-control border"
                              onChange={this.handleBandwidthCustomBitrateSettings}
                              value={this.state.screenShareCustomBitrate}>
                              {BANDWIDTH_CUSTOM_BANDWIDTH_LIST.map(bandwidth => (
                                <option key={bandwidth.value} value={bandwidth.value}>
                                  {bandwidth.bitrate ? bandwidth.bitrate : getMessage(bandwidth.name)}
                                </option>
                              ))}
                            </Input>
                          </Col>
                        </Row>
                      }
                    </Col>
                  </Row>            
                </Col>  
              </Row>
              <Row className="noMargin">
                <Col xs={3}></Col>
                <Col xs={9}>
                  {listOfAvailableSubModule.map((confirmScreenSubModules) => {
                    if (confirmScreenSubModules == "CONFIRM_SCREEN") {
                      return (
                        <Row className="pb-2 noMargin" key={confirmScreenSubModules}>
                          <Col xs={8}><span className="subtitle">
                            {getMessage(confirmScreenSubModules)}</span>
                          </Col>
                          <Col xs={4} className="switchBtnsMargin pl-2">
                            {this.renderSwitchConfirmScreen(confirmScreenSubModules,
                              this.props.isScreenShareSelected && this.state.subModulesScreenshare.hasOwnProperty(confirmScreenSubModules))}
                          </Col>
                        </Row>
                      )
                    }
                  }
                  )}
                </Col>
              </Row>
            </div>
          }
            
          { this.props.isSnapShotSelected &&
            <div className="section">
              <Row className="noMargin">
                <Col xs={3}>{getMessage("SNAP_SHOT")}</Col>
                <Col xs={9}>
                  {listOfAvailableSubModule.map((snapshotSubModules) => {
                    if (snapshotSubModules == "GUEST_TAKES_SS") {
                      return (
                        <Row className="pb-2 noMargin" key={snapshotSubModules}>
                          <Col xs={8}><span className="subtitle">
                            {getMessage(snapshotSubModules)}</span>
                          </Col>
                          <Col xs={4} className="switchBtnsMargin pl-2">
                            {this.renderSwitchSnapShot(snapshotSubModules,
                              this.props.isSnapShotSelected && this.state.subModulesSnapShot.hasOwnProperty(snapshotSubModules))}
                          </Col>
                        </Row>
                      )
                    }
                  }
                  )}
                </Col>
              </Row>

              <Row className="noMargin">
                <Col xs={3}></Col>
                <Col xs={9}>
                  {listOfAvailableSubModule.map((snapshotSubModules) => {
                    if (snapshotSubModules == "AUTO_SAVE_SS") {
                      return (
                        <Row className="pb-2 noMargin" key={snapshotSubModules}>
                          <Col xs={8}><span className="subtitle">
                            {getMessage(snapshotSubModules)}</span>
                          </Col>
                          <Col xs={4} className="switchBtnsMargin pl-2">
                            {this.renderSwitchSnapShot(snapshotSubModules,
                              this.props.isSnapShotSelected && this.state.subModulesSnapShot.hasOwnProperty(snapshotSubModules))}
                          </Col>
                        </Row>
                      )
                    }
                  }
                  )}
                </Col>
              </Row>
            </div>
          }
          <DropdownItem divider />

          {
            <div className="section">
              <Row className="noMargin">
                <Col className="mainTitle">
                  {getMessage("NOTIFICATION_SETTING")}
                </Col>
              </Row>
              <Row className="noMargin">
                <Col xs={5}>{getMessage("MAIL_SETTING")}:</Col>
                <Col xs={7}>
                  {
                    <Row className="pb-2 noMargin">
                      <Col xs={8}><span className="subtitle">
                        {getMessage("CHANGE_PASSWORD_SEND_MAIL")}</span>
                      </Col>
                      <Col xs={4} className="switchBtnsMargin">
                        {this.renderSwitchNotifySetting(notifySetting.PASSWORD_CHANGED_COMPLETED,
                          this.state.notifyPasswordChangeCompleted)}
                      </Col>
                    </Row>
                  }
                  {
                    this.props.availableModules.includes(modulesAvailableConstant.QR_CODE) &&
                    <Row className="pb-2 noMargin">
                      <Col xs={8}><span className="subtitle">
                        {getMessage("QR_CODE_SEND_MAIL")}</span>
                      </Col>
                      <Col xs={4} className="switchBtnsMargin">
                        {this.renderSwitchNotifySetting(notifySetting.QR_CODE,
                          this.state.notifyQRCode)}
                      </Col>
                    </Row>
                  }
                </Col>
              </Row>
              <DropdownItem divider />
            </div>
          }

          {this.renderStorageDetailSetting(STORAGE.STORAGE)}

          {this.props.availableModules.includes(Modules.CO_BROWSE) &&
          <>
            <DropdownItem divider />
              <CobrowseSettingsSection
                cobrowseRotation={this.state.cobrowseRotation}
                handleCobrowseArrowClick={this.handleCobrowseArrowClick}  
                isCobrowseToggler={this.state.isCobrowseToggler}
                allowCustomUrl={this.state.allowCustomUrl}
                setAllowCustomUrl={this.setAllowCustomUrl}
                handleCustomUrlInputChange={this.handleCustomUrlInputChange}
                customUrlLabels={this.state.customUrlLabels}
                showAddTargetSiteSection={this.state.showAddTargetSiteSection}
                targetSites={this.state.targetSites}
                handleAddTargetSiteIconClick={this.handleAddTargetSiteIconClick}
                handleDeleteUrlClick={this.handleDeleteUrlClick}
                handleUpdateTargetSiteClick={this.handleUpdateTargetSiteClick}
                showUpdateTargetSiteSection={this.state.showUpdateTargetSiteSection}
                onCancelCobrowseClick={this.onCancelCobrowseClick}
                handleCoBrowseInputChange={this.handleCoBrowseInputChange}
                targetSiteLabel={this.state.targetSiteLabel}
                targetSiteValue={this.state.targetSiteValue}
                cobrowseURLError={this.state.cobrowseURLError}
                handleAddTargetSiteClick={this.handleAddTargetSiteClick}
                customUrlLabelError={this.state.customUrlLabelError}
                coMutualEdit={this.state.mutualEdit}
                setCoBrowseMutualEditSwitchClick={this.setCoBrowseMutualEditSwitchClick}
                cobrowseType={this.state.cobrowseSettings.cobrowseType}
                renderSwitchFixedBrowse={this.renderSwitchFixedBrowse}
                subModulesCoBrowse={this.state.subModulesCoBrowse}
                isCoBrowseSelected={this.props.isCoBrowseSelected}
                updateFixedBrowse={this.updateFixedBrowse}
                disableInitiatingCoBrowse={this.state.disableInitiatingCoBrowse}
                setDisableInitiatingCoBrowseSwitchClick={this.setDisableInitiatingCoBrowseSwitchClick}
              />
            </>
          }
         
          {this.renderInboundCobrowse()}
          <DropdownItem divider />
          {this.renderUIGuestSettings()}

          {this.props.availableModules.includes(Modules.SUPPORT_CENTER) &&
            <>
              <DropdownItem divider />
              <SupportCenterSettingsSection
                isSupportCenterToggler={this.state.isSupportCenterToggler}
                operatorSkills={this.state.operatorSkills}
                handleSupportCenterArrowClick={this.handleSupportCenterArrowClick}
                targetSkillId={this.state.targetSkillId}
                targetSkillName={this.state.targetSkillName}
                targetReceptionStartTime={this.state.targetReceptionStartTime}
                targetReceptionEndTime={this.state.targetReceptionEndTime}
                targetIsReceptionDisabledOnExceptionDays
                  ={this.state.targetIsReceptionDisabledOnExceptionDays}
                targetExceptionStartTime={this.state.targetExceptionStartTime}
                targetExceptionEndTime={this.state.targetExceptionEndTime}
                targetExceptionDaysOfWeek={this.state.targetExceptionDaysOfWeek}
                targetContractDisplayMethod={this.state.targetContractDisplayMethod}
                handleSupportCenterInputChange={this.handleSupportCenterInputChange}
                handleSupportCenterNumericInputChange
                  ={this.handleSupportCenterNumericInputChange}
                handleSupportCenterReceptionHoursInputChange
                  ={this.handleSupportCenterReceptionHoursInputChange}
                handleSupportCenterCheckboxChange
                  ={this.handleSupportCenterCheckboxChange}
                handleAddOperatorSkillClick={this.handleAddOperatorSkillClick}
                handleSupportCenterExceptionDaysChange
                  ={this.handleSupportCenterExceptionDaysChange}
                skillErrorMessage={this.state.skillErrorMessage}
                showAddSkillSection={this.state.showAddSkillSection}
                showUpdateSkillSection={this.state.showUpdateSkillSection}
                onCancelOperatorSkillClick={this.onCancelOperatorSkillClick}
                operatorSkillIndexToEdit={this.state.operatorSkillIndexToEdit}
                handleAddOperatorSkillIconClick={this.handleAddOperatorSkillIconClick}
                handleUpdateOperatorSkillClick={this.handleUpdateOperatorSkillClick}
                handleDeleteOperatorSkillClick={this.handleDeleteOperatorSkillClick}
                operatorExclusiveRecordingControl={this.state.operatorExclusiveRecordingControl}
                updateOperatorExclusiveRecordingControl={this.updateOperatorExclusiveRecordingControl}
                ringtoneLoopEnabled={this.state.ringtoneLoopEnabled}
                updateRingtoneLoopEnabled={this.updateRingtoneLoopEnabled}
              />
              <DeleteConfirmationModal
                show={this.state.showDeleteConfirmationModalOperatorSkill}
                deleteTarget={this.state.deleteOperatorSkillName}
                handleCancelClick={this.handleModalCancelClickOperatorSkill}
                handleDeleteClick={this.handleModalDeleteClickOperatorSkill}
                parameter={this.state.deleteIndexOperatorSkill}
              />
            </>
          }
          <Row className="permissionButtons">
            {this.renderButtons()}
          </Row>
        </div>
      </div>
    )
  }
}

export default SettingsPage;
